<template>
  <div class="top-left w50 right margin margin_l_hf margin_r_c">
    <div
      class="styleCard"
      :class="{
        doneDebounce: colordBorder || loading
      }"
    >
      <div
        class="beta-item"
        v-if="systemDictionaries.hasOwnProperty('app_version')"
      >
        <!--        <span class="beta-icon">β </span>-->
        <form @submit.prevent="searchViki()" class="viki-search viki-search-form">
          <input
            v-model="vikiSearch"
            @keyup="offerVikiResults($event)"
            @click="showAllOptResults()"
            :placeholder="
              systemDictionaries.app_version.version
                ? 'β ' +
                  systemDictionaries.app_version.version +
                  ' | ' +
                  systemDictionaries.app_version.date
                : ''
            "
            type="text"
            class="viki-search viki-child"
            :class="resultsToShow.length?'b-0':''"
          />
          <i class="search-btn fas fa-search"  @click="searchViki"></i>

          <ul class="searches-container viki-child" v-if="resultsToShow.length" v-click-outside="resetOptionalMatches">
            <li @click="searchOptionalResult(result)"   class="search-preview" :class="[`search-option-${idx}`,idx===selectedResultIdx
            ?'search-preview-fake-hover':'']" v-for="(result,idx) in resultsToShow" :key="result.id">{{result.str_code}}</li>
          </ul>
        </form>
        <!--        <ul v-if="isSearchedTasks" >-->
        <!--          <li>Create Task</li>-->
        <!--          <li>Task Tab</li>-->
        <!--          <li>Completed Task</li>-->
        <!--        </ul>-->

        <!--        <span>-->
        <!--          {{ dictionaries.system.app_version.version }} |-->
        <!--          {{ dictionaries.system.app_version.date }}</span-->
        <!--        >-->
      </div>
      <div v-if="!newNeeds" class="ai-avatar">
        <div
          :class="{
            rootWindow: !tooBig,
            rootWindowTooBig: tooBig && CheckUserPermission([1, 2]),
            rootWindowTooBigForAgent: tooBig && !CheckUserPermission([1, 2])
          }"
        >
          <img
            v-if="loading && !showVikiMsg.show && !showWelcome"
            class="img-welcome "
            src="img/ai/viki-animations-new/Loading.gif"
          />

          <div
            v-if="
              showVikiMsg.type !== 'WARNING_BLOCK' &&
                showVikiMsg.type !== 'CONGRATS' &&
                showVikiMsg.type !== 'CA_COMING' &&
                showVikiMsg.type !== 'CA_MISSED' &&
                showVikiMsg.type !== 'ERROR' &&
                showVikiMsg.type !== 'SMS_SENT' &&
                showVikiMsg.type !== 'USER_DEPOSITED' &&
                showVikiMsg.type !== 'RECEIVE_CONGRATS' &&
                showVikiMsg.type !== 'PUSH_MORE' &&
                showVikiMsg.type !== 'WAKEUP' &&
                showVikiMsg.type !== 'STATISTICS' &&
                showVikiMsg.type !== 'CALL' &&
                showVikiMsg.op_code !== 'DEP_STATUS_BACK_TO_SALES'
            "
          >
            <img
              v-if="showWelcome && showGoodMorning"
              class="img-welcome"
              src="img/ai/viki-animations-new/GoodMorning.gif"
            />
            <img
              v-if="!showWelcome && morning && !loading"
              class="img-after-welcome"
              src="img/ai/viki-animations-new/StaticViki-MainImageAlway.gif"
            />

            <img
              v-if="showWelcome && showGoodAfternoon"
              class="img-welcome"
              src="img/ai/viki-animations-new/GoodEvening.gif"
            />
            <img
              v-if="!showWelcome && afternoon && !loading"
              class="img-after-welcome"
              src="img/ai/viki-animations-new/StaticViki-MainImageAlway.gif"
            />

            <img
              v-if="showWelcome && showGoodEvening"
              class="img-welcome"
              src="img/ai/viki-animations-new/GoodEvening.gif"
            />
            <img
              v-if="!showWelcome && evening && !loading"
              class="img-after-welcome"
              src="img/ai/viki-animations-new/StaticViki-MainImageAlway.gif"
            />

            <img
              v-if="showWelcome && showGoodNight && !loading"
              class="img-welcome"
              src="img/ai/viki-animations-new/GoodNight.gif"
            />
            <img
              v-if="!showWelcome && night && !loading"
              class="img-after-welcome "
              src="img/ai/viki-animations-new/StaticViki-MainImageAlway.gif"
            />
          </div>
          <img
            v-if="showVikiMsg.show && showVikiMsg.type === 'WARNING_BLOCK'"
            class="img-welcome"
            src="img/ai/viki-animations-new/Fill-In-all-the-details.gif"
          />

          <img
            v-if="showVikiMsg.show && showVikiMsg.type === 'RECEIVE_CONGRATS'"
            class="img-welcome agent-pic"
            :src="getUserImage(showVikiMsg.op.userId)"
          />

          <img
            v-if="
              showVikiMsg.show &&
                showVikiMsg.op_code === 'DEP_STATUS_BACK_TO_SALES'
            "
            class="img-welcome"
            src="img/ai/viki-animations-new/WorkWithHim.gif"
          />
          <img
            v-if="
              showVikiMsg.show &&
                showVikiMsg.type === 'STATISTICS' &&
                !showVikiMsg.cond &&
                showVikiMsg.op_code !== 'STATS_GEN_CLI'
            "
            class="img-welcome"
            src="img/ai/viki-animations-new/WakeUP.gif"
          />

          <img
            v-if="
              showVikiMsg.show &&
                showVikiMsg.type === 'STATISTICS' &&
                showVikiMsg.cond
            "
            class="img-welcome"
            src="img/ai/viki-animations-new/wow-greatjob.gif"
          />
          <img
            v-if="
              showVikiMsg.show &&
                showVikiMsg.type === 'STATISTICS' &&
                !showVikiMsg.cond &&
                loading
            "
            class="img-welcome"
            src="img/ai/viki-animations-new/WorkWithHim.gif"
          />
          <img
            v-if="
              showVikiMsg.show &&
                showVikiMsg.type === 'STATISTICS' &&
                showVikiMsg.op_code === 'STATS_GEN_CLI'
              // && loading
            "
            class="img-welcome"
            src="img/ai/viki-animations-new/wow-greatjob.gif"
          />

          <!--          <img-->
          <!--            v-if="showVikiMsg.show && showVikiMsg.type === 'USER_DEPOSITED'"-->
          <!--            class="img-welcome viki-when-dep-with-user"-->
          <!--            src="img/ai/viki-animations-new/wow-greatjob.gif"-->
          <!--          />-->

          <img
            v-if="showVikiMsg.show && showVikiMsg.type === 'SMS_SENT'"
            class="img-welcome"
            src="img/ai/viki-animations-new/sent-email-sms.gif"
          />
          <img
            v-if="showVikiMsg.show && showVikiMsg.type === 'CA_COMING'"
            class="img-welcome"
            src="img/ai/viki-animations-new/YouNeedTocallYourMembersoon.gif"
          />
          <img
            v-if="showVikiMsg.show && showVikiMsg.type === 'CA_MISSED'"
            class="img-welcome"
            src="img/ai/viki-animations-new/YouHaveMissedCallAgain.gif"
          />

          <img
            v-if="showVikiMsg.show && showVikiMsg.type === 'ERROR'"
            class="img-welcome"
            src="img/ai/viki-animations-new/Error.gif"
          />

          <img
            v-if="showVikiMsg.op && showVikiMsg.op.type === 'ASSIGN'"
            class="img-welcome"
            src="img/ai/viki-animations-new/assignclient.gif"
          />

          <img
            v-if="showVikiMsg.op && showVikiMsg.type === 'RECEIVE_ASSIGN'"
            class="img-welcome"
            src="img/ai/viki-animations-new/assignclient.gif"
          />
          <img
            v-if="showVikiMsg.op && showVikiMsg.type === 'CALL'"
            class="img-welcome"
            src="img/ai/viki-animations-new/sent-email-sms.gif"
          />
          <!--          <img-->
          <!--                  v-if="showVikiMsg.type === 'DONE_ORDER'"-->
          <!--                  class="img-welcome"-->
          <!--                  src="img/ai/viki-animations-new/sent-email-sms.gif"-->
          <!--          />-->
        </div>

        <div
          class="button-box"
          v-if="
            !showVikiMsg.show &&
              !showWelcome &&
              !finishLoading &&
              !loading &&
              !showVikiMsg.type &&
              !colordBorder
          "
        >
          <div class="container p0">
            <div class="row row-reset">
              <div class="">
                <i class="fas fa-info-circle info" @click="clickedOnInfo"></i>
              </div>

              <div class="">
                <i
                  class="far fa-envelope tagNameDesignForViki"
                  @click="
                    showMsgCenterSection = !showMsgCenterSection;
                    showAllNotifications = false;
                    showMsgCenter();
                  "
                ></i>
              </div>
              <!--            <button-->
              <!--              class="bttn blue"-->
              <!--              @click="-->
              <!--                showMsgCenterSection = !showMsgCenterSection;-->
              <!--                showAllNotifications = false;-->
              <!--                showMsgCenter();-->
              <!--              "-->
              <!--            >-->
              <!--              MESSAGES-->
              <!--            </button>-->
              <div class="">
                <i
                  class="fas fa-inbox tagNameDesignForViki"
                  @click="getLatestMessages()"
                ></i>
              </div>
              <!--            <button class="bttn blue" @click="getLatestMessages()">-->
              <!--              INBOX-->
              <!--            </button>-->
              <div v-if="CheckUserPermission([1, 2, 12])">
                <i
                  class="fas fa-coffee tagNameDesignForCoffee"
                  @click="hideVikiAndShowNeeds"
                ></i>
              </div>
              <div>
                <i
                  class="fas fa-hand-holding tagNameDesignForComeHere"
                  :class="{ disabledIt: !alllowSendingCostumeSms }"
                  @click="
                    [
                      hideVikiAndShowNeeds,
                      sendOrder('come To The Office Please')
                    ]
                  "
                ></i>
              </div>

              <div>
                <i @click="toggleHistory" class="fas fa-history history-btn">
                </i>
              </div>
            </div>
            <history-popup @onCloseModal="closeModal" v-if="isHistoryOpen" />
          </div>
        </div>
      </div>

      <div v-if="newNeeds && !showSuccessMessage" class="ai-avatar">
        <div class="container">
          <div class="col-md-4 for-coffee">
            <i
              class="fas fa-minus-circle"
              :class="{ disabledIt: coffieSum <= 1 }"
              @click="coffieSum <= 1 ? '' : (coffieSum -= 1)"
            ></i>
          </div>
          <div class="col-md-4 for-coffee" style="padding-left: 21px">
            {{ coffieSum }}
          </div>
          <div class="col-md-4 for-coffee">
            <i class="fas fa-plus-circle" @click="coffieSum += 1"></i>
          </div>
        </div>
        <div class="for-coffee-icone ">
          <div>
            <i
              class="fas fa-coffee icone-text"
              :class="{ disabledIt: !alllowSendingCostumeSms }"
              @click="sendOrder('coffee')"
            ></i>
          </div>
        </div>
        <span
          :class="{ disabledIt: !alllowSendingCostumeSms }"
          class="order"
          @click="sendOrder('coffee')"
          >Send</span
        >
        <div class="cancelOrder">
          <i
            class="fa fa-times for-hover-cancelOrder"
            aria-hidden="true"
            @click="[(newNeeds = false), (coffieSum = 1)]"
          ></i>
        </div>
      </div>

      <div
        v-if="
          showVikiMsg.show ||
            showWelcome ||
            (!showVikiMsg.show && (loading || finishLoading))
        "
        :style="returnTextColor"
      >
        <div
          class="forAll p7"
          v-if="showVikiMsg.show && showVikiMsg.type === 'TASK'"
        >
          <vue-typer
            :text="[
              auth.user.first_name +
                ` ` +
                `,` +
                removeHtml(textSize(showVikiMsg.msg))
            ]"
            :repeat="false"
            :shuffle="false"
            initial-action="typing"
            :pre-type-delay="670"
            :type-delay="0"
            :pre-erase-delay="1500"
            :erase-delay="250"
            erase-style="select-all"
            :erase-on-complete="false"
            caret-animation="blink"
            @typed-char="showBtn = false"
            @completed="showBtn = true"
          ></vue-typer>
        </div>

        <div v-if="showVikiMsg.show && showVikiMsg.type === 'INFO'" class="p15">
          <vue-typer
            :text="[
              auth.user.first_name +
                ` ` +
                auth.user.last_name +
                `,` +
                removeHtml(textSize(showVikiMsg.msg))
            ]"
            :repeat="false"
            :shuffle="false"
            initial-action="typing"
            :pre-type-delay="670"
            :type-delay="0"
            :pre-erase-delay="1500"
            :erase-delay="250"
            erase-style="select-all"
            :erase-on-complete="false"
            caret-animation="blink"
            @typed-char="showBtn = false"
            @completed="showBtn = true"
          ></vue-typer>
          <!--              ELI addition start -->

          <span
            v-if="
              showVikiMsg.options &&
                showVikiMsg.options.hasOwnProperty('country_alpha') &&
                (showVikiMsg.options.country_alpha !== null &&
                  showVikiMsg.options.country_alpha !== '')
            "
            class="country-img"
          >
            <img
              :src="
                `/img/flags/` +
                  showVikiMsg.options.country_alpha.toLowerCase() +
                  `.png`
              "
            />
          </span>
          <!--              ELI addition end -->
        </div>

        <div v-if="showVikiMsg.show && showVikiMsg.type === 'GENERAL'">
          <vue-typer
            :text="[
              auth.user.first_name +
                ` ` +
                auth.user.last_name +
                `,` +
                removeHtml(textSize(showVikiMsg.msg))
            ]"
            :repeat="false"
            :shuffle="false"
            initial-action="typing"
            :pre-type-delay="670"
            :type-delay="0"
            :pre-erase-delay="1500"
            :erase-delay="250"
            erase-style="select-all"
            :erase-on-complete="false"
            caret-animation="blink"
            @typed-char="showBtn = false"
            @completed="showBtn = true"
          ></vue-typer>
        </div>

        <div v-if="showVikiMsg.show && showVikiMsg.type === 'CALL'">
          <vue-typer
            :text="[removeHtml(textSize(showVikiMsg.msg))]"
            :repeat="false"
            :shuffle="false"
            initial-action="typing"
            :pre-type-delay="670"
            :type-delay="0"
            :pre-erase-delay="1500"
            :erase-delay="250"
            erase-style="select-all"
            :erase-on-complete="false"
            caret-animation="blink"
            @typed-char="showBtn = false"
            @completed="showBtn = true"
          ></vue-typer>
        </div>

        <div
          v-if="
            showVikiMsg.show &&
              showVikiMsg.type === 'STATISTICS' &&
              showVikiMsg.op_code === 'STATS_AVG_DEP'
          "
        >
          <vue-typer
            :text="[textSize(showVikiMsg.msg)]"
            :repeat="false"
            :shuffle="false"
            initial-action="typing"
            :pre-type-delay="670"
            :type-delay="0"
            :pre-erase-delay="1500"
            :erase-delay="250"
            erase-style="select-all"
            :erase-on-complete="false"
            caret-animation="blink"
            @typed-char="showGotItButton = false"
            @completed="showGotItButton = true"
          ></vue-typer>
          <!--           <span v-html="showVikiMsg.msg"></span> @completed='clear'-->
        </div>

        <!--chart section-->

        <div
          v-if="
            showVikiMsg.show &&
              showVikiMsg.type === 'STATISTICS' &&
              showVikiMsg.op_code === 'STATS_AVG_CR'
          "
        >
          <vue-typer
            :text="[
              checkPermissions(auth, [1, 2, 3, 4, 12])
                ? auth.user.first_name + ` ` + textSize(showVikiMsg.msg)
                : textSize(showVikiMsg.msg)
            ]"
            :repeat="false"
            :shuffle="false"
            initial-action="typing"
            :pre-type-delay="670"
            :type-delay="0"
            :pre-erase-delay="1500"
            :erase-delay="250"
            erase-style="select-all"
            :erase-on-complete="false"
            caret-animation="blink"
            @typed-char="showGotItButton = false"
            @completed="showGotItButton = true"
          ></vue-typer>
          <!--           <span v-html="showVikiMsg.msg"></span> @completed='clear'-->
        </div>

        <div
          v-if="
            showVikiMsg.show &&
              showVikiMsg.type === 'STATISTICS' &&
              showVikiMsg.op_code === 'STATS_GEN_CLI'
          "
        >
          <vue-typer
            :text="[textSize(showVikiMsg.msg)]"
            :repeat="false"
            :shuffle="false"
            initial-action="typing"
            :pre-type-delay="670"
            :type-delay="0"
            :pre-erase-delay="1500"
            :erase-delay="250"
            erase-style="select-all"
            :erase-on-complete="false"
            caret-animation="blink"
            @typed-char="showGotItButton = false"
            @completed="showGotItButton = true"
          ></vue-typer>
          <!--           <span v-html="showVikiMsg.msg"></span> @completed='clear'-->
        </div>

        <div v-if="showVikiMsg.show && showVikiMsg.type === 'ERROR'">
          <vue-typer
            :text="[
              // auth.user.first_name +
              //   ` ` +
              //   auth.user.last_name +
              //   `,` +
              removeHtml(textSize(showVikiMsg.msg))
            ]"
            :repeat="false"
            :shuffle="false"
            initial-action="typing"
            :pre-type-delay="670"
            :type-delay="0"
            :pre-erase-delay="1500"
            :erase-delay="250"
            erase-style="select-all"
            :erase-on-complete="false"
            caret-animation="blink"
            @typed-char="showBtn = false"
          ></vue-typer>
        </div>
        <!--
        @completed="[(showBtn = true)]"
-->

        <div
          v-if="
            showVikiMsg.show &&
              (showVikiMsg.type === 'DONE' || showVikiMsg.type === 'SMS_SENT')
          "
        >
          <strong>
            <vue-typer
              :text="[
                auth.user.first_name +
                  ` ` +
                  auth.user.last_name +
                  `\n` +
                  removeHtml(textSize(showVikiMsg.msg))
              ]"
              :repeat="false"
              :shuffle="false"
              initial-action="typing"
              :pre-type-delay="670"
              :type-delay="0"
              :pre-erase-delay="1500"
              :erase-delay="250"
              erase-style="select-all"
              :erase-on-complete="false"
              caret-animation="blink"
              @typed-char="showBtn = false"
              @completed="showBtn = false"
            ></vue-typer>
          </strong>
        </div>
        <div v-if="showVikiMsg.show && showVikiMsg.type === 'DONE_ORDER'">
          <strong>
            <vue-typer
              :text="[
                auth.user.first_name +
                  ` ` +
                  auth.user.last_name +
                  `,` +
                  removeHtml(textSize(showVikiMsg.msg))
              ]"
              :repeat="false"
              :shuffle="false"
              initial-action="typing"
              :pre-type-delay="670"
              :type-delay="0"
              :pre-erase-delay="1500"
              :erase-delay="250"
              erase-style="select-all"
              :erase-on-complete="false"
              caret-animation="blink"
              @typed-char="showBtn = false"
              @completed="
                [
                  (showBtn = true),
                  (newNeeds = false),
                  (showSuccessMessage = false),
                  (showVikiMsg.show = false)
                ]
              "
            ></vue-typer>
          </strong>
        </div>
        <div v-if="showVikiMsg.show && showVikiMsg.type === 'WARNING'">
          <vue-typer
            :text="[
              auth.user.first_name +
                ` ` +
                auth.user.last_name +
                `,` +
                textSize(showVikiMsg.msg)
            ]"
            :repeat="false"
            :shuffle="false"
            initial-action="typing"
            :pre-type-delay="670"
            :type-delay="0"
            :pre-erase-delay="1500"
            :erase-delay="250"
            erase-style="select-all"
            :erase-on-complete="false"
            caret-animation="blink"
            @typed-char="showBtn = false"
            @completed="showBtn = true"
          ></vue-typer>
        </div>

        <div v-if="showVikiMsg.show && showVikiMsg.type === 'TAG'">
          <vue-typer
            :text="[
              auth.user.first_name +
                ` ` +
                auth.user.last_name +
                `,` +
                textSize(showVikiMsg.msg) +
                `\n`
            ]"
            :repeat="false"
            :shuffle="false"
            :contentType="'html'"
            initial-action="typing"
            :pre-type-delay="670"
            :type-delay="0"
            :pre-erase-delay="1500"
            :erase-delay="250"
            erase-style="select-all"
            :erase-on-complete="false"
            caret-animation="blink"
            @typed-char="showBtn = false"
            @completed="showBtn = true"
          ></vue-typer>
          <div
            class="container"
            v-if="
              showVikiMsg.op.tag_id === 1 &&
                (Object.keys(BNTimer).length > 1 || showVikiMsg.op.cond) &&
                showBtn
            "
          >
            <div
              class="row"
              v-for="client in Object.keys(BNTimer)"
              :key="client"
            >
              <div class="col-3">
                #{{ client }}
                <a @click="cancelTag(client)">Cancel</a>
              </div>
            </div>
          </div>

          <div
            class="container"
            v-if="
              showVikiMsg.op.tag_id === 2 &&
                (Object.keys(NITimer).length > 1 || showVikiMsg.op.cond) &&
                showBtn
            "
          >
            <div
              class="row"
              v-for="client in Object.keys(NITimer)"
              :key="client"
            >
              <div class="col-3">
                #{{ client }}
                <a @click="cancelTag(client)">Cancel</a>
              </div>
            </div>
          </div>
        </div>

        <div v-if="showVikiMsg.show && showVikiMsg.type === 'WARNING_BLOCK'">
          <vue-typer
            :text="[
              auth.user.first_name +
                ` ` +
                auth.user.last_name +
                `,` +
                removeHtml(textSize(showVikiMsg.msg))
            ]"
            :repeat="false"
            :shuffle="false"
            initial-action="typing"
            :pre-type-delay="670"
            :type-delay="0"
            :pre-erase-delay="1500"
            :erase-delay="250"
            erase-style="select-all"
            :erase-on-complete="false"
            caret-animation="blink"
            @typed-char="showBtn = false"
            @completed="showBtn = true"
          ></vue-typer>
        </div>

        <div
          class="dep new-dep"
          v-if="showVikiMsg.show && showVikiMsg.type === 'USER_DEPOSITED'"
        >
          <img
            v-if="showId && showBtn && showCnImg"
            class="img-welcome for-agent-pic-dep"
            :src="getUserImage(showVikiMsg.op.userId)"
          />
          <vue-typer
            :text="[removeBrokerName(textSize(showVikiMsg.msg))]"
            :repeat="false"
            :shuffle="false"
            initial-action="typing"
            :pre-type-delay="670"
            :type-delay="0"
            :pre-erase-delay="1500"
            :erase-delay="250"
            erase-style="select-all"
            :erase-on-complete="false"
            caret-animation="blink"
            @completed="
              showId = true;
              showBtn = true;
              showCnImg = true;
            "
            @typed-char="
              showId = false;
              showBtn = false;
              showCnImg = false;
            "
          ></vue-typer>
          <div class="flag-and-id">
            <span
              v-if="showCnImg && showVikiMsg.options.countryAlpha"
              class="country-img"
            >
              <img
                :src="
                  `/img/flags/` +
                    showVikiMsg.options.countryAlpha.toLowerCase() +
                    `.png`
                "
              />
            </span>

            <span
              v-if="checkPermissions(auth, [1, 2, 3, 4, 12]) && showId"
              @click="setClientToFilter(showVikiMsg.op.clientId)"
            >
              <a class="client-id-msg">#{{ showVikiMsg.op.clientId }}</a></span
            >
          </div>
        </div>
        <div
          class="mt-30"
          v-if="showVikiMsg.show && showVikiMsg.type === 'RECEIVE_CONGRATS'"
        >
          <strong>
            <vue-typer
              :text="[textSize(showVikiMsg.msg)]"
              :repeat="false"
              :shuffle="false"
              initial-action="typing"
              :pre-type-delay="670"
              :type-delay="0"
              :pre-erase-delay="1500"
              :erase-delay="250"
              erase-style="select-all"
              :erase-on-complete="false"
              caret-animation="blink"
              @completed="(showId = true), (showBtn = true)"
              @typed-char="showId = false"
            ></vue-typer>
          </strong>
        </div>
        <div
          v-if="
            showVikiMsg.show && showVikiMsg.type === 'RECEIVE_CONGRATS_BDAY'
          "
        >
          <strong>
            <vue-typer
              :text="[textSize(showVikiMsg.msg)]"
              :repeat="false"
              :shuffle="false"
              initial-action="typing"
              :pre-type-delay="670"
              :type-delay="0"
              :pre-erase-delay="1500"
              :erase-delay="250"
              erase-style="select-all"
              :erase-on-complete="false"
              caret-animation="blink"
              @completed="showBtn = true"
              @typed-char="showBtn = false"
            ></vue-typer>
          </strong>
        </div>
        <div v-if="showVikiMsg.show && showVikiMsg.type === 'SAY_THANKS'">
          <strong>
            <vue-typer
              :text="[textSize(showVikiMsg.msg)]"
              :repeat="false"
              :shuffle="false"
              initial-action="typing"
              :pre-type-delay="670"
              :type-delay="0"
              :pre-erase-delay="1500"
              :erase-delay="250"
              erase-style="select-all"
              :erase-on-complete="false"
              caret-animation="blink"
              @completed="showBtn = true"
              @typed-char="showBtn = false"
            ></vue-typer>
          </strong>
        </div>
        <div
          class="mt-30"
          v-if="showVikiMsg.show && showVikiMsg.type === 'DEPOSIT_FROM_NI'"
        >
          <strong>
            <vue-typer
              :text="[textSize(showVikiMsg.msg)]"
              :repeat="false"
              :shuffle="false"
              initial-action="typing"
              :pre-type-delay="670"
              :type-delay="0"
              :pre-erase-delay="1500"
              :erase-delay="250"
              erase-style="select-all"
              :erase-on-complete="false"
              caret-animation="blink"
              @completed="showBtn = true"
              @typed-char="showBtn = false"
            ></vue-typer>
          </strong>
        </div>
        <div
          v-if="showVikiMsg.show && showVikiMsg.type === 'SENT_CONGRATE_BDAY'"
        >
          <strong>
            <vue-typer
              :text="[textSize(showVikiMsg.msg)]"
              :repeat="false"
              :shuffle="false"
              initial-action="typing"
              :pre-type-delay="670"
              :type-delay="0"
              :pre-erase-delay="1500"
              :erase-delay="250"
              erase-style="select-all"
              :erase-on-complete="false"
              caret-animation="blink"
              @completed="showBtn = true"
              @typed-char="showBtn = false"
            ></vue-typer>
          </strong>
        </div>
        <div v-if="showVikiMsg.show && showVikiMsg.type === 'CA_MISSED'">
          <!--            class="alert alert-danger"-->
          <!--             <strong-->
          <!--            role="alert"-->
          <!--              >{{ auth.user.first_name }} {{ auth.user.last_name }},-->
          <!--            </strong>-->
          <!--            {{ showVikiMsg.msg }}-->
          <!--            ` ` +-->
          <!--            // auth.user.last_name +-->

          <vue-typer
            :text="[
              auth.user.first_name +
                `, ` +
                removeHtml(textSize(showVikiMsg.msg))
            ]"
            :repeat="false"
            :shuffle="false"
            initial-action="typing"
            :pre-type-delay="670"
            :type-delay="0"
            :pre-erase-delay="1500"
            :erase-delay="250"
            erase-style="select-all"
            :erase-on-complete="false"
            caret-animation="blink"
            @typed-char="showBtn = false"
            @completed="showBtn = true"
          ></vue-typer>
        </div>
        <!--          ` ` +-->
        <!--          auth.user.last_name +-->
        <div v-if="showVikiMsg.show && showVikiMsg.type === 'CA_COMING'">
          <strong>
            <vue-typer
              :text="[
                auth.user.first_name +
                  `, ` +
                  removeHtml(textSize(showVikiMsg.msg))
              ]"
              :repeat="false"
              :shuffle="false"
              initial-action="typing"
              :pre-type-delay="670"
              :type-delay="0"
              :pre-erase-delay="1500"
              :erase-delay="250"
              erase-style="select-all"
              :erase-on-complete="false"
              caret-animation="blink"
              @typed-char="showBtn = false"
              @completed="showBtn = true"
            ></vue-typer>
          </strong>
        </div>
        <div v-if="showVikiMsg.show && showVikiMsg.type === 'TASK_MISSED'">
          <strong>
            <vue-typer
              :text="[
                auth.user.first_name +
                  ` ` +
                  auth.user.last_name +
                  `,` +
                  removeHtml(textSize(showVikiMsg.msg))
              ]"
              :repeat="false"
              :shuffle="false"
              initial-action="typing"
              :pre-type-delay="670"
              :type-delay="0"
              :pre-erase-delay="1500"
              :erase-delay="250"
              erase-style="select-all"
              :erase-on-complete="false"
              caret-animation="blink"
              @typed-char="showBtn = false"
              @completed="showBtn = true"
            ></vue-typer>
          </strong>
        </div>
        <div v-if="showVikiMsg.show && showVikiMsg.type === 'TRAN_CONF'">
          <strong>
            <vue-typer
              :text="[
                auth.user.first_name +
                  ` ` +
                  auth.user.last_name +
                  `,` +
                  removeHtml(textSize(showVikiMsg.msg)) +
                  ` to client`
              ]"
              :repeat="false"
              :shuffle="false"
              initial-action="typing"
              :pre-type-delay="670"
              :type-delay="0"
              :pre-erase-delay="1500"
              :erase-delay="250"
              erase-style="select-all"
              :erase-on-complete="false"
              caret-animation="blink"
              @typed="
                showClientFilter = false;
                showBtn = false;
              "
              @completed="
                showClientFilter = true;
                showBtn = true;
              "
            ></vue-typer>
          </strong>
          <a
            v-if="showClientFilter"
            class="client-id-msg"
            @click="setClientToFilter(showVikiMsg.op.clientId)"
            >#{{ showVikiMsg.op.clientId }}</a
          >
        </div>

        <!--        :class="{-->
        <!--        'welcome-message': !tooBig ,-->
        <!--        'welcome-message-small': tooBig && CheckUserPermission([1, 2])-->
        <!--        }"-->
        <!--        <div-->
        <!--          v-if="auth.user.first_name && showWelcome && showVikiMsg.type === ''"-->
        <!--        >-->
        <!--          <div class="blessing-time">-->
        <!--                    <vue-typer-->
        <!--                      :text="[-->
        <!--                        textSize(showVikiMsg.msg) +-->
        <!--                          '\n ' +-->
        <!--                          '     ' +-->
        <!--                          textSize(auth.user.first_name)-->
        <!--                      ]"-->
        <!--                      :repeat="false"-->
        <!--                      :shuffle="false"-->
        <!--                      initial-action="typing"-->
        <!--                      :pre-type-delay="670"-->
        <!--                      :type-delay="0"-->
        <!--                      :pre-erase-delay="2000"-->
        <!--                      :erase-delay="250"-->
        <!--                      erase-style="select-all"-->
        <!--                      :erase-on-complete="false"-->
        <!--                      caret-animation="blink"-->
        <!--                      @typed-char="showBtn = false"-->
        <!--                      @completed="showBtn = true"-->
        <!--                    ></vue-typer>-->
        <!--          </div>-->
        <!--        </div>-->
        <div
          v-if="!showWelcome && !showVikiMsg.show && showVikiMsg.type === ''"
          class="crm-message"
        ></div>
        <div v-if="showVikiMsg.show && showVikiMsg.type === 'RECEIVE_ASSIGN'">
          <vue-typer
            :text="[
              auth.user.first_name +
                ` ` +
                auth.user.last_name +
                `\n` +
                textSize(showVikiMsg.msg)
            ]"
            :repeat="false"
            :shuffle="false"
            initial-action="typing"
            :pre-type-delay="670"
            :type-delay="0"
            :pre-erase-delay="1500"
            :erase-delay="250"
            erase-style="select-all"
            :erase-on-complete="false"
            caret-animation="blink"
            @typed-char="[(showBtn = false), (showId = false)]"
            @completed="[(showBtn = true), (showId = true)]"
          ></vue-typer>
          <!--              <span v-if="checkPermissions(auth, [1, 2, 3, 4]) && showId">-->

          <span v-if="showVikiMsg.op.clientId !== null && showId">
            <a
              class="client-id-msg"
              @click="[setClientToFilter(showVikiMsg.op.clientId), approved()]"
            >
              #{{ showVikiMsg.op.clientId }}</a
            ></span
          >
        </div>
        <!--        <div-->
        <!--            v-if="-->
        <!--            loading &&-->
        <!--              !showVikiMsg.show &&-->
        <!--              !showWelcome &&-->
        <!--              showVikiMsg.msg === ''-->
        <!--          "-->
        <!--        >-->
        <!--          <strong v-if="!newNeeds">-->
        <!--            <vue-typer-->
        <!--                :text="[textSize('      Please wait\nI am  processing data')]"-->
        <!--                :repeat="false"-->
        <!--                :shuffle="false"-->
        <!--                initial-action="typing"-->
        <!--                :pre-type-delay="670"-->
        <!--                :type-delay="-5000"-->
        <!--                :pre-erase-delay="1500"-->
        <!--                :erase-delay="250"-->
        <!--                erase-style="select-all"-->
        <!--                :erase-on-complete="false"-->
        <!--                caret-animation="blink"-->
        <!--                @typed-char="showBtn = false"-->
        <!--                @completed="tooBig = false"-->
        <!--            ></vue-typer>-->
        <!--          </strong>-->
        <!--        </div>-->

        <!--        <div-->
        <!--            v-if="finishLoading && !loading && !showVikiMsg.show && !showWelcome"-->
        <!--        >-->
        <!--          <strong v-if="!newNeeds">-->
        <!--            <vue-typer-->
        <!--                :text="[textSize('      im Ready')]"-->
        <!--                :repeat="false"-->
        <!--                :shuffle="false"-->
        <!--                initial-action="typing"-->
        <!--                :pre-type-delay="670"-->
        <!--                :type-delay="0"-->
        <!--                :pre-erase-delay="1500"-->
        <!--                :erase-delay="250"-->
        <!--                erase-style="select-all"-->
        <!--                :erase-on-complete="false"-->
        <!--                caret-animation="blink"-->
        <!--                @typed-char="showBtn = false"-->
        <!--                @completed="tooBig = false"-->
        <!--            ></vue-typer>-->
        <!--          </strong>-->
        <!--        </div>-->

        <div v-if="showVikiMsg.op_code === 'STATISTICS_FOR_S_C'">
          <vue-typer
            class="temp-for-s_c"
            :text="[auth.user.first_name + ` ` + textSize(showVikiMsg.msg)]"
            :repeat="false"
            :shuffle="false"
            initial-action="typing"
            :pre-type-delay="670"
            :type-delay="0"
            :pre-erase-delay="1500"
            :erase-delay="250"
            erase-style="select-all"
            :erase-on-complete="false"
            caret-animation="blink"
            @typed-char="showGotItButton = false"
            @completed="showGotItButton = true"
          ></vue-typer>
          <!--           <span v-html="showVikiMsg.msg"></span> @completed='clear'-->
        </div>

        <div class="row btn-bar">
          <div
            class="col-sm-12 buttons-area"
            v-if="showVikiMsg.show || showWelcome"
          >
            <button
              v-if="
                showVikiMsg.type !== 'USER_DEPOSITED' &&
                  showVikiMsg.type !== 'RECEIVE_CONGRATS' &&
                  showVikiMsg.type !== 'RECEIVE_CONGRATS_BDAY' &&
                  showVikiMsg.type !== 'SAY_THANKS' &&
                  showVikiMsg.type !== 'DEPOSIT_FROM_NI' &&
                  showVikiMsg.type !== 'SENT_CONGRATE_BDAY' &&
                  showVikiMsg.type !== 'RECEIVE_ASSIGN' &&
                  showVikiMsg.type !== 'CA_MISSED' &&
                  showVikiMsg.type !== 'CA_COMING' &&
                  showVikiMsg.type !== 'TRAN_CONF' &&
                  (showVikiMsg.op && showVikiMsg.op.type !== 'SYSTEM') &&
                  showVikiMsg.op_code === null &&
                  showVikiMsg.type !== '' &&
                  showBtn
              "
              class="btn btn-md btn-approved"
              @click="approved"
            >
              Approve {{ showVikiMsg.type }}
            </button>
            <button
              class="btn btn-md btn-approved ml6 "
              @click="approved"
              v-if="showVikiMsg.type === 'DEPOSIT_FROM_NI'"
            >
              <i class="far fa-thumbs-up"></i>
            </button>
            <!--              ELI addition start -->
            <button
              v-if="
                showVikiMsg.op &&
                  showVikiMsg.op.hasOwnProperty('client_id') &&
                  showVikiMsg.cond === 1
              "
              class="btn btn-md btn-approved for-filter-my-clients"
              @click="setClientToFilter(showVikiMsg.op.client_id)"
              v-tooltip.top="{ content: 'filter client(s)' }"
            >
              Filter It
            </button>
            <button
              v-if="showVikiMsg.cond === 1"
              class="btn btn-md btn-approved remind-me later"
              @click="decline"
            >
              Later
            </button>
            <!--              ELI addition end-->
            <div
              class="remind-btns"
              v-if="
                showVikiMsg.op &&
                  showVikiMsg.op_code === 'DEP_STATUS_BACK_TO_SALES'
              "
            >
              <!--  removed class:for-remind-in-h-->
              <button
                v-if="
                  showVikiMsg.op &&
                    showVikiMsg.op_code === 'DEP_STATUS_BACK_TO_SALES'
                "
                class="btn btn-md btn-approved "
                @click="decline"
                v-tooltip.top="{ content: 'Remind me in 1 hour' }"
              >
                R-1
              </button>

              <!--  removed class: for-remind-tomorrow-->
              <button
                v-if="
                  showVikiMsg.op &&
                    showVikiMsg.op_code === 'DEP_STATUS_BACK_TO_SALES'
                "
                class="btn btn-md btn-approved "
                @click="decline"
                v-tooltip.top="{ content: 'Remind me tomorrow' }"
              >
                R-T
              </button>

              <!--  removed class:for-filter-my-clients-->
              <button
                v-if="
                  showVikiMsg.op &&
                    showVikiMsg.op_code === 'DEP_STATUS_BACK_TO_SALES'
                "
                class="btn btn-md btn-approved "
                @click="takeMeToMyClientsDep('DEP_STATUS_BACK_TO_SALES')"
                v-tooltip.top="{ content: 'filter client(s)' }"
              >
                F
              </button>
            </div>

            <div
              v-if="showVikiMsg.type === 'USER_DEPOSITED' && showBtn"
              class="forBorder"
            ></div>
            <button
              v-if="showVikiMsg.type === 'USER_DEPOSITED' && showBtn"
              class="btn btn-md btn-approved special"
              @click="congrats"
              v-tooltip.top="{ content: 'Approve' }"
            >
              <i class="far fa-thumbs-up"></i>
            </button>

            <!--  <button
                v-if="
                  CheckUserPermission([1, 2, 3, 4]) &&
                    showVikiMsg.type === 'USER_DEPOSITED' &&
                    showBtn
                "
                class="btn btn-md btn-approved"
                @click="filterCongratsDep"
              >
                Say Congrats & Filter client
              </button>-->
            <!--            (showVikiMsg.op && showVikiMsg.op.type === 'SYSTEM')-->
            <button
              v-if="showVikiMsg.type === 'RECEIVE_CONGRATS' && showBtn"
              class="btn btn-md btn-approved remind-me"
              @click="clear"
            >
              Clear
            </button>
            <button
              v-if="showVikiMsg.type === 'RECEIVE_CONGRATS_BDAY' && showBtn"
              class="btn btn-md btn-approved remind-me"
              @click="clear"
            >
              Clear
            </button>

            <button
              v-if="showVikiMsg.type === 'SENT_CONGRATE_BDAY' && showBtn"
              class="btn btn-md btn-approved remind-me"
              @click="clear"
            >
              Clear
            </button>
            <button
              v-if="showVikiMsg.type === 'RECEIVE_CONGRATS_BDAY' && showBtn"
              class="btn btn-md btn-approved remind-me"
              @click="sayThanksBday"
            >
              SAY THANKS
            </button>

            <button
              v-if="showVikiMsg.type === 'SAY_THANKS' && showBtn"
              class="btn btn-md btn-approved remind-me"
              @click="clear"
            >
              CLEAR
            </button>

            <button
              v-if="showVikiMsg.type === 'GENERAL' && showBtn"
              class="btn btn-md btn-approved ml-70"
              @click="clear"
            >
              <i class="far fa-thumbs-up "></i>

              <!--              {{-->
              <!--                showVikiMsg.options.op === "WEEK" ?-->
              <!--              <i class="far fa-thumbs-up"></i>:-->
              <!--              <i class="far fa-thumbs-up"></i>-->

              <!--              "Thank-you!" : "Thank-you!"-->
              <!--              }}-->
            </button>

            <button
              v-if="
                showVikiMsg.show &&
                  showVikiMsg.type === 'STATISTICS' &&
                  showVikiMsg.op_code !== 'STATISTICS_FOR_S_C' &&
                  (showGotItButton || chartsList.includes(showVikiMsg.op_code))
              "
              class="btn btn-md btn-approved for-filter-my-clients"
              @click="clear"
            >
              Thanks
            </button>

            <button
              v-if="
                showVikiMsg.op && showVikiMsg.op.type === 'ASSIGN' && showBtn
              "
              class="btn btn-md btn-decline"
              @click="showAssignMenu = true"
            >
              Assign #{{ showVikiMsg.op.clientId }}
            </button>

            <button
              v-if="
                showVikiMsg.op &&
                  showVikiMsg.type === 'RECEIVE_ASSIGN' &&
                  showBtn
              "
              class="btn btn-md btn-approved remind-me later"
              @click="decline"
            >
              Later
            </button>
            <!--              @click="setClientToFilter(showVikiMsg.op.clientId)"-->

            <button
              v-if="
                showVikiMsg.op &&
                  showVikiMsg.type === 'RECEIVE_ASSIGN' &&
                  showBtn &&
                  showVikiMsg.op.clientId !== null
              "
              class="btn btn-md btn-approved"
              @click="setClientToFilter(showVikiMsg.op.clientId)"
            >
              Filter it!
            </button>

            <button
              v-if="
                showVikiMsg.op && showVikiMsg.op.type === 'CA_COMING' && showBtn
              "
              class="btn btn-md btn-approved call-now"
              @click="showCaComingClient"
            >
              Call now
            </button>

            <button
              v-if="showVikiMsg.op && showVikiMsg.op.type === 'NAC'"
              class="btn btn-md btn-approved"
              @click="activateClient(showVikiMsg.op.clientId)"
            >
              Activate #{{ showVikiMsg.op.clientId }}
            </button>
            <button
              v-if="
                showVikiMsg.type !== 'USER_DEPOSITED' &&
                  showVikiMsg.type !== 'RECEIVE_CONGRATS' &&
                  showVikiMsg.type !== 'DEPOSIT_FROM_NI' &&
                  showVikiMsg.type !== 'CA_MISSED' &&
                  showVikiMsg.type !== 'CA_COMING' &&
                  showVikiMsg.type !== 'TRAN_CONF' &&
                  (showVikiMsg.op && showVikiMsg.op.type !== 'SYSTEM') &&
                  showVikiMsg.op_code === null &&
                  showVikiMsg.type !== '' &&
                  showBtn
              "
              class="btn btn-md btn-decline"
              @click="decline"
            >
              Decline
            </button>
            <button
              v-if="
                showVikiMsg.op && showVikiMsg.type === 'CA_MISSED' && showBtn
              "
              class="btn btn-md btn-decline-long"
              @click="decline"
              v-tooltip.top="{ content: 'I know I will call soon' }"
            >
              Will Do
            </button>

            <button
              v-if="
                showVikiMsg.op && showVikiMsg.type === 'CA_COMING' && showBtn
              "
              class="btn btn-md btn-decline-long-coming-call remind-me"
              @click="saveScheduledCall(showVikiMsg.op.clientId[0].id)"
            >
              remind me
            </button>

            <button
              v-if="
                showVikiMsg.show &&
                  showVikiMsg.type === 'TAG' &&
                  showBtn &&
                  !showVikiMsg.op.cond
              "
              class="btn btn-md btn-dangerr for-fa-times"
              @click="cancelTag(showVikiMsg.op.clientId)"
            >
              <i class="fas fa-times"></i>
            </button>
            <button
              v-if="
                showVikiMsg.type === 'WARNING' &&
                  showVikiMsg.op.type === 'CANCEL TASK' &&
                  showBtn
              "
              class="btn btn-md btn-decline"
            >
              no
            </button>
            <button
              style="margin-left: 20px"
              v-if="
                showVikiMsg.type === 'WARNING' &&
                  showVikiMsg.op.type === 'CANCEL TASK' &&
                  showBtn
              "
              class="btn btn-md btn-approved"
              @click="cancelTask(showVikiMsg.op.taskId)"
            >
              Yes
            </button>
            <button
              v-if="
                showVikiMsg.type === 'TASK' &&
                  showBtn &&
                  !showVikiMsg.options.hasOwnProperty('button')
              "
              class="btn btn-md btn-approved  filter-task ml-37"
              @click="clearTaskMsg('GTT')"
              v-tooltip.top="{ content: 'Take me to the tasks' }"
            >
              Filter-Task
            </button>
            <button
              v-if="
                showVikiMsg.type === 'TASK' &&
                  showBtn &&
                  !showVikiMsg.options.hasOwnProperty('button')
              "
              class="btn btn-md btn-approved later ml-37"
              @click="clearTaskMsg"
              v-tooltip.top="{ content: 'I\'ll check latter on' }"
            >
              Later
            </button>
            <button
              v-if="
                showVikiMsg.type === 'TASK' &&
                  showBtn &&
                  showVikiMsg.options.hasOwnProperty('button') &&
                  showVikiMsg.options.button === 'meeting-complete'
              "
              class="btn btn-md btn-approved meeting-opt not-now"
              @click="clearMeetingMsg"
              v-tooltip.top="{ content: 'remind me in 1 hour' }"
            >
              not now
            </button>
            <button
              v-if="
                showVikiMsg.type === 'TASK' &&
                  showBtn &&
                  showVikiMsg.options.hasOwnProperty('button') &&
                  showVikiMsg.options.button === 'meeting-complete'
              "
              class="btn btn-md btn-approved for-filter-my-clients ml-45 meeting-opt"
              @click="clearMeetingMsg('GTTM', meetingIdForPreOpen)"
              v-tooltip.top="{ content: 'Take me to complete the meeting' }"
            >
              <!--              complete the meeting-->
              <i class="far fa-thumbs-up"></i>
            </button>

            <div class="date-time-div">
              <vue-typer
                v-if="showVikiMsg.op && showVikiMsg.type"
                :text="[
                  showVikiMsg.updatedAt
                    ? formatDate(showVikiMsg.updatedAt)
                    : getCurrentDate()
                ]"
                :repeat="false"
                :shuffle="false"
                initial-action="typing"
                :pre-type-delay="670"
                :type-delay="0"
                :pre-erase-delay="1500"
                :erase-delay="250"
                erase-style="select-all"
                :erase-on-complete="false"
                caret-animation="blink"
              ></vue-typer>
            </div>
            <!--              <button-->
            <!--                  v-if="showVikiMsg.op && showVikiMsg.type === 'CALL' &&-->
            <!--                    showBtn"-->
            <!--                  class="btn btn-md btn-approved"-->
            <!--                  @click="clear"-->
            <!--              >-->
            <!--                Clear-->
            <!--              </button>-->
            <div v-if="showVikiMsg.op && showVikiMsg.type === 'CA_COMING'">
              <md-progress-spinner
                v-if="loading"
                :md-diameter="25"
                :md-stroke="3"
                md-mode="indeterminate"
                class="spinner-noti-box"
              ></md-progress-spinner>
            </div>

            <button
              v-if="
                showVikiMsg.op && showVikiMsg.type === 'TRAN_CONF' && showBtn
              "
              class="btn btn-md btn-approved for-filter-my-clients"
              @click="showTransMenu = true"
            >
              Choose User
            </button>
            <button
              v-if="
                showVikiMsg.op && showVikiMsg.type === 'TRAN_CONF' && showBtn
              "
              class="btn btn-md btn-decline for-filter-my-clients"
              @click="transferConfirm(null)"
            >
              You Decide
            </button>
            <div class="floating-wrapper">
              <ul v-if="showTransMenu" class=" p-xy-8 assignment-dropdown-menu">
                <li
                  @click="transferConfirm(person.id)"
                  class="assign-menu-item"
                  v-for="person in salesPersonList"
                  :key="person.id"
                >
                  {{ person.first_name + " " + person.last_name }}
                </li>
              </ul>
            </div>

            <div class="floating-wrapper">
              <ul
                v-if="showAssignMenu"
                class=" p-xy-8 assignment-dropdown-menu"
              >
                <li
                  @click="saveAssignment(person)"
                  class="assign-menu-item"
                  v-for="person in salesPersonList"
                  :key="person.id"
                >
                  {{ person.first_name + " " + person.last_name }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import apiClientCreator from "../../../helpers/api/request";
import moment from "moment";
import VueTyper from "../components/vue_typer/components/VueTyper";
import UsersPermissionCheck from "../../../mixins/user/auth/UsersPermissionCheck";
import SocketEndpoints from "../../../mixins/system/SocketEndpoints";
import { Globals } from "../../../global_constants/constants";
import HistoryPopup from "../components/HistoryPopup.component";
import ClickOutside from "vue-click-outside";
//import MatrixViewComponent from "../../company.feature/sub_features.company/graph.sub-feature.company/components/matrix_view/MatrixViewComponent";
//import LiveVikiDeposits from "../../statistics.feature/misc.sub_feature/liveVikiDeposits.stats/containers/LiveVikiDeposits.container";

//LiveVikiDeposits
export default {
  name: "notifications.component",
  components: {
    VueTyper,
    HistoryPopup
  },
  mixins: [UsersPermissionCheck, SocketEndpoints],

  computed: {
    ...mapState("main", ["showVikiMsg"]),
    ...mapState("user", ["auth"]),
    ...mapState("clients", [
      "dictionaries",
      "salesPersonList",
      "DebounceAll",
      "showReset",
      "BNTimer",
      "NITimer",
      "loading",
      "refreshAll",
      "openCaComponent"
    ]),
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapGetters("clients", ["loading", "filterClientId", "filterCaMissed"]),
    ...mapState("globalSearch", ["currentSearch"]),
    ...mapState("system", ["systemDictionaries"]),

    returnTextColor() {
      let color = "#827717";

      if (
        (this.showVikiMsg.type === "STATISTICS" && this.showVikiMsg.cond) ||
        this.showVikiMsg.type === "USER_DEPOSITED"
      ) {
        color = "#008b00";
      } else if (
        (this.showVikiMsg.type === "STATISTICS" && !this.showVikiMsg.cond) ||
        this.showVikiMsg.type === "ERROR"
      ) {
        color = "#ac1f06";
      }
      return "color:" + color;
    }
    // isSearchedTasks(){
    //   const formattedSearch = this.formatSearch(this.currentSearch)
    //   if(formattedSearch==='task'||formattedSearch==='tasks') return true;
    //   return false;
    // } // currently unused
  },

  data() {
    return {
      selectedResultIdx:-1,
      resultsToShow:[],
      clickedOnInfoViki: false,
      vikiSearch: "",
      bdayBlessFromId: "",
      isHistoryOpen: false,
      meetingIdForPreOpen: null,
      showCnImg: false,
      showWelcome: true,
      showAssignMenu: false,
      showTransMenu: false,
      showNotficationLayout: true,
      showAllNotifications: false,
      showAllNotificationsBtn: false,
      showMsgCenterSection: false,
      showBtn: false,

      interval: null,
      showClientFilter: false,
      showGotItButton: false,
      showId: false,
      msgCenterData: [],
      notificationsData: [],
      socketNotify: "",
      newMessage: "",
      typeWriterText: "",
      clearTypeMessages: [
        "RECEIVE_CONGRATS",
        "SMS_SENT",
        // "INFO",
        "ERROR",
        "DONE",
        "WARNING",
        "WARNING_BLOCK",
        "CALL",
        "STATISTICS"
      ],
      longClearTypeMessages: ["STATISTICS"],
      approveTypeMessages: ["INFO", "CA_MISSED", "CALL"],
      finishLoading: false,
      loadingTimeout: null,
      chartsList: ["STATS_AVG_CR_CHART", "STATS_GEN_CLI_RETENTION_CHART"],
      waitedToLong: false,
      tempCount: null,
      tooBig: false,

      showGoodMorning: false,
      showGoodAfternoon: false,
      showGoodEvening: false,
      showGoodNight: false,

      morning: false,
      afternoon: false,
      evening: false,
      night: false,

      userImg: "img/ai/viki-gif/Deposit.gif",
      flag: false,
      newNeeds: false,
      coffieSum: 1,
      showSuccessMessage: false,
      fClick: false,
      sClick: false,
      colordBorder: false,
      showRequestOpt: false,
      alllowSendingCostumeSms: true
    };
  },
  mounted() {
    setTimeout(() => {
      this.colordBorder = false;
    }, 5000);
    this.setImg();
    this.setWelcome();
  },
  directives:{
    ClickOutside
  },
  created() {
    ///TODO: ADD ON CONNECTION TO SOCKET IO
    setTimeout(() => {
      this.sendUserIDToMsg();
    }, 6000);
    this.msgSocket.on("connect", () => {
      setTimeout(() => {
        if (this.msgSocket.hasOwnProperty("id")) {
          this.$store.commit(
            "clients/setProfileSocketSessionID",
            this.msgSocket.id
          );
          this.sendUserIDToMsg();
        }
      }, 6000);
    });
    this.msgSocket.on("userDepositedNi", data => {
      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        id: data._id,
        msg: data.message,
        type: "DEPOSIT_FROM_NI",
        op: { type: "" },
        op_code: data.op_code || null
      });
    });
    this.msgSocket.on("LOGOUT_COMMAND", confirmation => {
      if (confirmation === "OK") {
        this.logOutUser();
      }
    });

    this.msgSocket.on("receiveAllMessages", data => {
      this.msgCenterData = data;
    });

    this.msgSocket.on("receiveMessage", data => {
      let msgFrom = ``;
      if (data.message_from !== 28) {
        msgFrom = ` ,from  ${this.getPersonName(data.message_from).full_name}`;
      }

      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        id: data._id,
        msg: " " + data.message + msgFrom,
        type: "INFO",
        op: { type: "" },
        op_code: data.op_code || null, //TODO: new logic
        updatedAt: data.updatedAt
      });

      // if(data.type === 'USER_DEPOSITED'){
      //   this.$notification.show(
      //       "New Message Received !",
      //       {
      //         body: `${data.message}  from ${
      //             this.getPersonName(data.message_from).full_name
      //         }`
      //       },
      //       {}
      //   );
      // }
    });
    this.msgSocket.on("receiveMessage", data => {
      let msgFrom = ``;
      if (data.message_from !== 28) {
        msgFrom = ` ,from  ${this.getPersonName(data.message_from).full_name}`;
      }

      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        id: data._id,
        msg: " " + data.message + msgFrom,
        type: "INFO",
        op: { type: "" },
        op_code: data.op_code || null, //TODO: new logic
        updatedAt: data.updatedAt
      });

      // if(data.type === 'USER_DEPOSITED'){
      //   this.$notification.show(
      //       "New Message Received !",
      //       {
      //         body: `${data.message}  from ${
      //             this.getPersonName(data.message_from).full_name
      //         }`
      //       },
      //       {}
      //   );
      // }
    });

    this.msgSocket.on("receiveGeneralMessage", data => {
      const payload = {
        show: true,
        id: data._id,
        msg: data.message,
        type: "GENERAL",
        op_code: data.op_code,
        cond: data.cond,
        updatedAt: data.updatedAt,
        options: data.options
      };
      if (data.hasOwnProperty("client_id")) {
        Object.assign(payload, {
          op: { type: "", clientId: data.client_id }
        });
      }
      this.$store.commit("main/setShowVikiMsg", payload);
    });
    this.msgSocket.on("receiveStatsMessage", data => {
      // let msgFrom = ``;
      // if (data.message_from !== 28) {
      //   msgFrom = ` ,from  ${this.getPersonName(data.message_from).full_name}`;
      // }
      let payLoad = {
        show: true,
        id: data._id,
        msg: " " + data.message,
        type: "STATISTICS",
        op: { type: "" },
        op_code: data.op_code, //TODO: new logic
        cond: data.cond,
        options: data.options,
        updatedAt: data.updatedAt
      };
      if (data.hasOwnProperty("sub_cond")) {
        payLoad.sub_cond = data.sub_cond;
      }
      this.$store.commit("main/setShowVikiMsg", payLoad);
      // this.$notification.show(
      //     "New Message Received !",
      //     {
      //       body: `${data.message}  from ${
      //           this.getPersonName(data.message_from).full_name
      //       }`
      //     },
      //     {}
      // );
    });

    this.msgSocket.on("receiveMessageNewDeposit", data => {
      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        id: data._id,
        msg: data.message,
        type: data.type,
        op: { userId: data.message_from, clientId: data.client_id },
        updatedAt: data.updatedAt,
        options: data.options
      });

      this.$notification.show(
        "New Deposit!\n",
        {
          body: `${data.message}  from\n ${
            this.getPersonName(data.message_from).full_name
          }`
        },
        {}
      );
    });

    this.msgSocket.on("receiveCaMissed", data => {
      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        id: data._id,
        msg: `${data.message}`,
        type: data.type,
        op: {
          userId: data.crm_user_id,
          type: "CA_MISSED",
          clientId: data.client_id
        },
        updatedAt: data.updatedAt,
        options: data.options
      });

      // this.$notification.show(
      //   "Missed Calls !",
      //   {
      //     body: `${data.message}, from Viki`
      //   },
      //   {}
      // );
    });

    this.msgSocket.on("receiveCaComing", data => {
      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        id: data._id,
        msg: `${data.message} ${this.getCountryName(
          data.clients[0].country_id
        )}`,
        type: data.type,
        op: {
          userId: data.crm_user_id,
          type: "CA_COMING",
          clientId: data.clients
        },
        options: data.options,
        updatedAt: data.updatedAt
      });

      /*            this.$notification.show('Scheduled Call !', {
      body: `${data.message}, from  Viki`,
    }, {})*/
    });

    // this.trSocket.on("receive_transfer_request", req => {
    //   this.$store.commit("main/setShowVikiMsg", {
    //     show: true,
    //     id: req._id,
    //     msg: `Transfer request from\n ${
    //       this.getPersonName(req.req_crm_user_id).full_name
    //     }`,
    //     type: "TRAN_CONF",
    //     op: {
    //       userId: req.req_crm_user_id,
    //       type: "TRAN_CONF",
    //       clientId: req.client_id
    //     },
    //     options: data.options,
    //     updatedAt: data.updatedAt
    //   });
    //
    //   this.$notification.show(
    //     "Transfer Confirmation",
    //     {
    //       body: `Transfer request\n from ${
    //         this.getPersonName(req.req_crm_user_id).full_name
    //       }`
    //     },
    //     {}
    //   );
    // });

    this.msgSocket.on("receiveCongrats", data => {
      const officalName = this.getOfficialName(this.auth.user);
      const congratsFrom = this.getPersonName(data.message_from);
      const congratsFromOfficial = this.getOfficialName(congratsFrom);
      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        id: data._id,
        msg: `Congrats ${officalName} \n from ${congratsFromOfficial}`,
        type: data.type,
        op: { userId: data.message_from, type: "RECEIVE_CONGRATS" },
        options: data.options,
        updatedAt: data.updatedAt
      });

      this.$notification.show(
        "Congrats!\n",
        {
          body: `${data.message}  from ${
            this.getPersonName(data.message_from).full_name
          }`
        },
        {}
      );
    });
    this.msgSocket.on("reciveCongratsBday", data => {
      this.bdayBlessFromId = data.message_from;
      const msg = this.$store.commit("main/setShowVikiMsg", {
        show: true,
        id: data._id,
        msg: data.message,
        type: data.type,
        op: { userId: data.message_from, type: "RECEIVE_CONGRATS_BDAY" },
        options: data.options,
        updatedAt: data.updatedAt
      });
    });

    this.msgSocket.on("getThanks", data => {
      const msg = this.$store.commit("main/setShowVikiMsg", {
        show: true,
        id: data._id,
        msg: data.message,
        type: data.type,
        op: { userId: data.message_from, type: "getThanks" },
        options: data.options,
        updatedAt: data.updatedAt
      });
    });
    this.msgSocket.on("receiveTaskMessage", data => {
      let options = {};
      let msg;
      if (data.options.msg_type === "REP") {
        msg = `${
          this.getPersonName(data.message_from).full_name
        } Replied to a Task #${data.options.task_id}
       }`;
        // At ${this.formatDate(
        //   data.options.date
        // )
      }
      if (data.options.msg_type === "NEW") {
        msg = `${
          this.getPersonName(data.message_from).full_name
        } sent you a New task #${data.options.task_id} on ${this.formatDate(
          data.options.date
        )}`;
      }
      if (data.options.msg_type === "MEETINGANNOUNCEMENT") {
        msg = `${
          this.getPersonName(data.message_from).full_name
        } reminds that\n ${data.message} #${
          data.options.task_id
        } on\n ${this.formatDate(data.options.date)}`;
      }
      if (data.options.msg_type === "MEETINGCOMPLETE") {
        this.meetingIdForPreOpen = data.options.task_id;
        options.button = "meeting-complete";

        msg = `${this.getOfficialName(
          this.getPersonName(data.message_from)
        )}\n Please Sum up the last meeting #${data.options.task_id}`;
      }

      // this.$store.commit("main/setShowVikiMsg", {
      //   show: true,
      //   id: data._id,
      //   msg: msg,
      //   type: data.type,
      //   updatedAt: data.updatedAt,
      //   op: opt
      // });

      if (data.options.msg_type === "NEWMEETING") {
        // ${ this.getPersonName(data.message_from).full_name}
        msg = ` you have new meeting on \n ${this.formatDate(
          data.options.date
        )}`;
      }
      let dataOptions = data.options;
      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        id: data._id,
        msg: msg,
        type: data.type,
        updatedAt: data.updatedAt,
        options: { ...options, dataOptions }
      });
    });
  },

  watch: {
    currentSearch: function() {
      if (this.currentSearch === "") return; //  avoid unwanted code execution
      const TASK_TAB_POSSIBILITYS = ["tasks", "tasktab", "tabtask"]; // this.dicnary.task
      const CREATE_TASK_POSSIBILITYS = ["createtask", "newtask"];
      const COMPLETED_TASK_POSSIBILITYS = ["completed", "completedtasks"];
      const ACTIVE_TASK_POSSIBILITYS = ["active", "activetasks"];
      const WAITING_TASK_POSSIBILITYS = ["waiting", "waitingtasks"];
      const AS_VS_DEP_POSSIBLITYS = [
        "depositsvsassignments",
        "assignmentsvsdeposits",
        "asvsdep",
        "depvsas",
        "assvsdep",
        "depvsass"
      ];
      const ASSIGN_STATS_POSSIBLITYS = ["assignstats", "statsassign"];
      const REG_POSSIBLITYS = ["reg", "register", "registration"];
      const COUNTRY_POSSIBILITYS = ["country"];

      TASK_TAB_POSSIBILITYS.some(pos => {
        if (this.formatSearch(this.currentSearch).includes(pos)) {
      this.openTasksFromSearch()
        }
      });
      CREATE_TASK_POSSIBILITYS.some(pos => {
        if (this.formatSearch(this.currentSearch).includes(pos)) {
          this.createTaskFromSearch()
 }
      });

      COMPLETED_TASK_POSSIBILITYS.some(pos => {
        if (this.formatSearch(this.currentSearch).includes(pos)) {
          this.openSpecificTasksFromSearch("completed")
  }
      });
      ACTIVE_TASK_POSSIBILITYS.some(pos => {
        if (this.formatSearch(this.currentSearch).includes(pos)) {
          this.openSpecificTasksFromSearch("active")
     }
      });
      WAITING_TASK_POSSIBILITYS.some(pos => {
        if (this.formatSearch(this.currentSearch).includes(pos)) {
          this.openSpecificTasksFromSearch("waiting")
  }
      });
      AS_VS_DEP_POSSIBLITYS.some(pos => {
        if (this.formatSearch(this.currentSearch).includes(pos)) {
          this.setGlobalActionOnMain("openDepVsAssignTab")
        }
      });
      ASSIGN_STATS_POSSIBLITYS.some(pos => {
        if (this.formatSearch(this.currentSearch).includes(pos)) {
        this.setGlobalActionOnMain("openAssignStats");
        }
      });
      REG_POSSIBLITYS.some(pos => {
        if (this.formatSearch(this.currentSearch).includes(pos)) {
          this.setGlobalActionOnMain("openRegTab")
        }
      });
      COUNTRY_POSSIBILITYS.some(pos => {
        if (this.formatSearch(this.currentSearch).includes(pos)) {
          this.setGlobalActionOnMain("open_country_popup")
        }
      });
    },

    tooBig: function() {
      setTimeout(e => {
        this.colordBorder = false;
        this.tooBig = false;
      }, 6000);
    },
    // "showVikiMsg.type": function() {
    //   if (this.showVikiMsg.type === "ERROR") {
    //
    //   }
    // },
    // finishLoading:function(){
    // finishLoading:function(){
    //
    //   this.tempCount = setTimeout(() => {
    //     this.waitedToLong = true;
    //
    //   }, 15000);
    //   if(this.finishLoading){
    //     clearTimeout(this.tempCount);
    //   }
    // },

    loading: function() {
      if (!this.loading) {
        clearTimeout(this.CencelAllTimeOut);
        this.waitedToLong = false;

        clearTimeout(this.loadingTimeout);
        this.finishLoading = true;

        this.loadingTimeout = setTimeout(() => {
          this.finishLoading = false;
        }, 3000);
        return true;
      }

      // this.waitedToLong = true;
      // /this.colordBorder = true; // TODO: REMOVED 28-02-21 made bug that not stopped the loader!!

      this.CencelAllTimeOut = setTimeout(() => {
        this.waitedToLong = true;
      }, 15000);
    },

    "showVikiMsg.msg": function() {
      if (this.showVikiMsg.msg.length > 25) {
        this.tooBig = true;
      } else {
        this.tooBig = false;
      }
      if (this.interval) {
        clearTimeout(this.interval);
      }
      if (this.showVikiMsg.type === "TAG") {
        this.setClearMessage(60);
      }
      // this.sendMsgToMysql(this.showVikiMsg)
    },

    "showVikiMsg.type": function() {
      this.showBtn = false;
      /*
      "RECEIVE_CONGRATS",
      "SENT_CONGRATE_BDAY",
      "SMS_SENT",
      "ERROR",
      "DONE",
       "WARNING",
       "WARNING_BLOCK"
        */

      /** Short clear type messages will auto clear and send approve(ignored) after 10 sec */

      if (this.clearTypeMessages.includes(this.showVikiMsg.type)) {
        return setTimeout(() => {
          this.$store.commit("main/setShowVikiMsg", {
            show: false,
            msg: "",
            type: "",
            op: {
              type: "",
              clientId: null,
              userId: null
            },
            options: null,
            updatedAt: null
          });
        }, 10000);
      }

      /** Short approve type messages will auto clear and send approve(ignored) after 30 sec */

      if (this.approveTypeMessages.includes(this.showVikiMsg.type)) {
        return setTimeout(() => {
          const id = this.auth.user.id;
          this.msgSocket.emit("answer_notification", {
            crm_user_id: id,
            msg_id: this.showVikiMsg.id,
            message: this.showVikiMsg.msg,
            approved: null,
            type: this.showVikiMsg.type,
            tag: "none",
            operation: "no"
          });

          this.showAssignMenu = false;
          this.$store.commit("main/setShowVikiMsg", {
            show: false,
            id: null,
            msg: "",
            type: "",
            op: {
              type: "",
              clientId: null,
              userId: null
            },
            options: null,
            updatedAt: null
          });
        }, 60000);
      }

      /** Long clear type messages will auto clear and send approve(ignored) after 15 min */

      if (this.longClearTypeMessages.includes(this.showVikiMsg.type)) {
        return setTimeout(() => {
          const id = this.auth.user.id;
          this.msgSocket.emit("answer_notification", {
            crm_user_id: id,
            msg_id: this.showVikiMsg.id,
            message: this.showVikiMsg.msg,
            approved: null,
            type: this.showVikiMsg.type,
            tag: "none",
            operation: "no"
          });

          this.showAssignMenu = false;
          this.$store.commit("main/setShowVikiMsg", {
            show: false,
            id: null,
            msg: "",
            type: "",
            op: {
              type: "",
              clientId: null,
              userId: null
            },
            options: null,
            updatedAt: null
          });
        }, 15 * 60 * 1000);
      }
    }
  },

  methods: {

    offerVikiResults(ev){
      // if(!this.vikiSearch) return this.resetOptionalMatches()
      if(ev.code==="ArrowDown" || ev.code==="ArrowUp" || ev.code==="Enter") return this.handleNavigateOnSearchList(ev.code)
      const searchValue = this.formatSearch(this.vikiSearch);
      const allOptionalMatches = this.systemDictionaries.global_feature_functions;

      let matchedSearches =[]
      allOptionalMatches.forEach(optMatch=>{
        const strKeysToSearch = optMatch.optional_searches.split(" ")
        if(strKeysToSearch.find(strKey=>strKey.includes(searchValue))) matchedSearches.push(optMatch);
      })
      this.resultsToShow=matchedSearches;
    },
    showAllOptResults(){
      if(!this.vikiSearch){
        setTimeout(()=>{
          this.resultsToShow = this.systemDictionaries.global_feature_functions
        },50)
      }
    },
    clickedOnInfo() {
      this.clickedOnInfoViki = true;
      this.$store.commit("clients/setClickOnViki", this.clickedOnInfoViki);
    },
    handleNavigateOnSearchList(action){
      const selectedIdx = this.selectedResultIdx
      if(!this.resultsToShow.length) return; // Avoid unwanted code execution.

      if(action==="ArrowDown" && selectedIdx<=this.resultsToShow.length-1){
        selectedIdx===this.resultsToShow.length-1? this.selectedResultIdx=0: this.selectedResultIdx++;
      }
      else if(action==="ArrowUp" && selectedIdx>=0 ){
        selectedIdx===0? this.selectedResultIdx=this.resultsToShow.length-1:this.selectedResultIdx--;
      }
      else if(action==="Enter" && selectedIdx>0 ){
        this.searchOptionalResult(this.resultsToShow[selectedIdx])
        this.selectedResultIdx=0
      }
    },
     searchOptionalResult(result){
      this.resetOptionalMatches()
      switch (result.system_function_name){
      case "open_tasks":
        this.openTasksFromSearch()
        break
        case "open_active_tasks":
        this.openSpecificTasksFromSearch("active")
        break
        case "open_completed_tasks":
        this.openSpecificTasksFromSearch("completed")
        break
        case "open_waiting_tasks":
        this.openSpecificTasksFromSearch("waiting")
        break;
        case "open_country":
        this.setGlobalActionOnMain("open_country_popup")
        break;
        case "new_task":
        this.createTaskFromSearch()
        break;
        case "ass_vs_dep":
          this.setGlobalActionOnMain("openDepVsAssignTab")
        break;
        case "assign_stats":
        this.setGlobalActionOnMain("openAssignStats")
        break;
        case "reg_report":
        this.setGlobalActionOnMain("openRegTab")
        break;

      }
    },

resetOptionalMatches(){
      this.vikiSearch="";
      this.resultsToShow=[]
  this.selectedResultIdx=0;
},
    formatSearch(str) {
      //This function makes the search CLEAN: its lowercasing the text,
      // removes whitespaces between, after, and inside the search input.
      return str
        .toLowerCase()
        .trim()
        .split(" ")
        .join("");
    },

    openTasksFromSearch(){
      if (this.$route.name === "Tasks") return; // prevent route to /tasks from /tasks
      this.$router.push("/tasks"); // routing to /tasks
      this.$store.commit("globalSearch/search", ""); // resetting the global search query
    },
    createTaskFromSearch(){
      this.$store.commit(
          "globalSearch/setNewGlobalAction",
          "open-new-task"
      ); // resetting the global search query
      this.$store.commit("globalSearch/search", ""); // resetting the global search query
      if (this.$route.name !== "Tasks") return this.$router.push("/tasks");
    },
    openSpecificTasksFromSearch(diffTasks){
      this.$store.commit(
          "globalSearch/setNewGlobalAction",
          `open-${diffTasks}-task`
      );
      this.$store.commit("globalSearch/search", ""); // resetting the global search query
      if (this.$route.name !== "Tasks") this.$router.push("/tasks");

    },
    setGlobalActionOnMain(action){
      setTimeout(async ()=>{
          await this.$store.commit("globalSearch/search", ""); // resetting the global search query
        this.$store.commit("globalSearch/setNewGlobalAction", action);
      },50) // Need to be async. dont know why, but this is only work that way. need to see why.
      if (this.$route.name !== "Main") this.$router.push("/");
    },

    closeModal() {
      this.isHistoryOpen = false;
    },
    toggleHistory() {
      this.isHistoryOpen = !this.isHistoryOpen;
    },
    searchViki() {
      if(this.resultsToShow.length) return;
      this.$store.commit("globalSearch/search", this.vikiSearch);
      // Clear Input content
      this.vikiSearch = "";
    },
    sayThanksBday() {
      this.clear();
      const fromUser = this.auth.user;
      const fromUserOfficial = this.getOfficialName(fromUser);
      const toUser = this.salesPersonList.find(
        person => person.id === this.bdayBlessFromId
      );
      const message = `Thanks from ${fromUserOfficial}`;
      this.msgSocket.emit("say_thanks", {
        fromUser,
        toUser,
        message,
        approved: "APPROVED",
        type: "SAY_THANKS",
        tag: "none"
      });
    },
    // debounceIt() { //TODO: REMOVED 28-02-21 wrong arch
    //   if (this.fClick && this.loading) {
    //     this.fClick = !this.fClick;
    //     this.StopProcessing();
    //     return true;
    //   }
    //   this.fClick = !this.fClick;
    //
    //   this.$store.commit("clients/setDebounceAll", true);
    // },
    restAll() {
      this.$store.commit("clients/setRefreshAll", true);
    },
    sendOrder(preset, msg = "") {
      this.alllowSendingCostumeSms = false;
      const sendSMSReq = apiClientCreator(`client/sms/sendCostumeSms`);

      if (preset === "coffee") {
        if (this.auth.user.id === Globals.first_owner_id) {
          if (this.coffieSum > 1) {
            msg = ` Eden make me a ${coffieSum} cups of coffee please, Mike `;
          } else {
            msg = ` Eden make me a cup of coffee please, Mike `;
          }
        } else if (this.auth.user.id === Globals.second_owner_id) {
          msg = " Eden make me an espresso please, Guy";
        }
      }
      if (preset === "come To The Office Please") {
        if (this.auth.user.id === Globals.first_owner_id) {
          msg = ` Eden Please Come To The Office, Mike  `;
        } else if (this.auth.user.id === Globals.second_owner_id) {
          msg = " Eden Please Come To The Office, Guy";
        }
      }
      sendSMSReq
        .post("", {
          preset: msg,
          userId: 107,
          message: msg
        })
        .then(e => {
          this.alllowSendingCostumeSms = true;
          this.coffieSum = 1;
          this.newNeeds = false;
          this.showSuccessMessage = true;
          this.$store.commit("main/setShowVikiMsg", {
            show: true,
            msg: "Order Sent Successfully",
            type: "DONE_ORDER"
          });
        })
        .catch(e => {
          this.coffieSum = 1;
          this.alllowSendingCostumeSms = true;
        });
    },
    getOfficialName(person) {
      let officialName = "";
      officialName +=
        person.first_name.charAt(0).toUpperCase() +
        person.first_name.slice(1) +
        " ";
      officialName += person.last_name.charAt(0).toUpperCase() + ".";
      return officialName;
    },
    hideVikiAndShowNeeds() {
      this.showRequestOpt = false;
      this.newNeeds = true;
    },
    changeVikiClaps(userImg) {
      this.interval = setTimeout(() => {
        this.userImg = userImg;
        this.interval = null;
      }, 5000);
    },
    setImg() {
      const format = "hh:mm:ss";

      const time = moment();

      const morningStart = moment("05:01:00", format);
      const morningEnd = moment("11:00:00", format);

      const afternoonStart = moment("11:01:00", format);
      const afternoonEnd = moment("16:00:00", format);

      const eveningStart = moment("16:01:00", format);
      const eveningEnd = moment("22:00:00", format);

      const nightStart = moment("22:01:00", format);
      const nightEnd = moment("23:59:00", format);
      const nightStart2 = moment("00:00:00", format);
      const nightEnd2 = moment("05:59:00", format);

      if (time.isBetween(morningStart, morningEnd)) {
        this.showGoodMorning = true;
        this.morning = true;
      }

      if (time.isBetween(afternoonStart, afternoonEnd)) {
        this.showGoodAfternoon = true;
        this.afternoon = true;
      }

      if (time.isBetween(eveningStart, eveningEnd)) {
        this.showGoodEvening = true;
        this.evening = true;
      }

      if (
        time.isBetween(nightStart, nightEnd) ||
        time.isBetween(nightStart2, nightEnd2)
      ) {
        this.showGoodNight = true;
        this.night = true;
      }

      setTimeout(() => {
        this.showWelcome = false;
      }, 5800);
    },
    textSize(text) {
      if (text.length > 0) {
        this.tooBig = true;
        if (text.length < 5) {
          return "    " + text;
        }
        return text;
      } else {
        this.tooBig = false;
        return text;
      }
    },
    // stopCounting() {
    //   this.waitedToLong = false;
    //   clearTimeout(this.CencelAllTimeOut);
    // },

    // StopProcessing() { //TODO: REMOVED 28-02-21 wrong arch
    //   this.$store.commit("clients/setStopProcess", true);
    //   this.fClick = !this.fClick;
    //   this.restAll();
    //   this.waitedToLong = false;
    //
    //   // window.stop();
    //
    //   for (let i = 0; i < 20; i++) {
    //     setTimeout(e => {
    //       this.$store.commit("clients/setLoading", false);
    //       window.stop();
    //     }, 100 * i);
    //   }
    //
    //   this.waitedToLong = false;
    //   clearTimeout(this.CencelAllTimeOut);
    //
    //   // this.cancelTask.abort();
    //   // this.apiClient.abort();
    //   // this.activateRequest.abort();
    //   // this.assignRequest.abort();
    // },
    getUserImage(userId) {
      const person = this.salesPersonList.find(user => user.id === userId);
      if (person) {
        if (!person.profile_img) return "img/header/avatar.png";
        return person.profile_img;
      }
    },
    goToTasks() {
      let vm = this;
      vm.$router.push("/tasks");
    },
    cancelTask(taskId) {
      this.$store.commit("clients/setLoading", true);

      const cancelTask = apiClientCreator(`tasks/cancel_task/${taskId}`);
      cancelTask.post("").then(res => {});
      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        msg: "Task cancelled",
        type: "DONE",
        op: { type: "SYSTEM" }
      });
      this.$store.commit("clients/setLoading", false);
      this.$store.commit("tasks/setFetchTasks", { flag: true });
    },
    setClearMessage(sec) {
      this.interval = setTimeout(() => {
        this.$store.commit("main/setShowVikiMsg", {
          show: false,
          id: null,
          msg: "",
          type: "",
          op: {
            type: "",
            clientId: null,
            userId: null
          },
          options: null
        });
      }, sec * 1000);
    },
    cancelTag(client_Id = this.showVikiMsg.op.clientId) {
      let clientId = parseInt(client_Id);
      if (this.showVikiMsg.op.tag_id === 1) {
        if (this.BNTimer.hasOwnProperty(clientId)) {
          clearTimeout(this.BNTimer[clientId]);
          let tempObj = Object.assign({}, this.BNTimer);
          delete tempObj[clientId];
          this.$store.commit("clients/setBNTimer", tempObj);
          this.$store.commit("clients/setClearClientTags", {
            tag: 1,
            clientId: clientId
          });
          if (Object.keys(this.BNTimer).length === 0) {
            this.clear();
          }
        }
      }
      if (this.showVikiMsg.op.tag_id === 2) {
        if (this.NITimer.hasOwnProperty(clientId)) {
          clearTimeout(this.NITimer[clientId]);
          let tempObj = Object.assign({}, this.NITimer);
          delete tempObj[clientId];
          this.$store.commit("clients/setNITimer", tempObj);
          this.$store.commit("clients/setClearClientTags", {
            tag: 2,
            clientId: clientId
          });
          if (Object.keys(this.NITimer).length === 0) {
            this.clear();
          }
        }
      }
      if (!this.showVikiMsg.op.cond) {
        this.clear();
      }

      this.showWelcome = false;
    },
    getCurrentDate() {
      return moment().format("DD/MM/YY HH:mm");
    },
    removeBrokerName(msg) {
      if (this.CheckUserPermission([1, 2, 3, 4])) {
        return msg;
      }
      let newMessage = msg;
      this.dictionaries.general.brokers.map(broker => {
        newMessage = newMessage.replace(broker.name, "");
      });
      return newMessage;
    },
    logOutUser() {
      let vm = this;
      vm.$store.dispatch("user/logOut").then(() => {
        vm.$router.push("/login");
      });
    },
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    },
    getLatestMessages() {
      const data = this.auth.user.id;
      this.msgSocket.emit("get_latest_msg", data);
    },
    openMeetingToComplete(taskId) {
      this.$store.commit("tasks/setFilterByTaskId", { id: taskId });
    },
    sendUserIDToMsg() {
      const data = this.auth.user.id;
      this.msgSocket.emit("send_id", data);
    },

    transferConfirm(transferTo) {
      const answer = {
        req_crm_user_id: this.showVikiMsg.op.userId,
        conf_crm_user_id: this.auth.user.id,
        client_id: this.showVikiMsg.op.clientId,
        // transfer_type:Number,
        is_confirmed: true,
        conf_to_crm_user_id: transferTo
      };

      // this.$socket.emit("send_transfer_confirm", answer);

      this.showTransMenu = false;
      this.$store.commit("main/setShowVikiMsg", {
        show: false,
        msg: "",
        type: "",
        op: {
          type: "",
          clientId: null,
          userId: null
        },
        options: null,
        updatedAt: null
      });
    },

    showMsgCenter() {
      this.msgSocket.emit("all_messages", this.auth.user.id);
    },

    sendMessage(msg) {
      const id = this.auth.user.id;
      // this.msgSocket.emit("receive_message", { crm_user_id: id, message: msg ,type:'ANNC',priority:12});
      this.msgSocket.emit("receive_message", {
        message_from: id,
        message: msg,
        type: "ANNC",
        priority: 12
      });
      this.newMessage = "";
      this.msgSocket.emit("all_messages", this.auth.user.id);
    },

    // allNotifications() {
    //   const id = this.auth.user.id;
    //   //  this.$socket.emit("receive_all_notifications", { crm_user_id: id });
    //   notifySocket.emit("receive_all_notifications", { crm_user_id: id });
    //   //alert();
    // },

    decline() {
      const id = this.auth.user.id;
      this.msgSocket.emit("answer_notification", {
        crm_user_id: id,
        msg_id: this.showVikiMsg.id,
        message: this.showVikiMsg.msg,
        approved: "DECLINED",
        type: this.showVikiMsg.type,
        tag: "none",
        operation: "no"
      });

      this.showAssignMenu = false;
      this.$store.commit("main/setShowVikiMsg", {
        show: false,
        id: null,
        msg: "",
        type: "",
        op: {
          type: "",
          clientId: null,
          userId: null
        },
        options: null,
        updatedAt: null
      });
      //  this.msgSocket.emit("all_messages");
    },

    approved() {
      const id = this.auth.user.id;
      this.msgSocket.emit("answer_notification", {
        crm_user_id: id,
        msg_id: this.showVikiMsg.id,
        message: this.showVikiMsg.msg,
        approved: "APPROVED",
        type: this.showVikiMsg.type,
        tag: "none",
        operation: "no"
      });

      this.$store.commit("main/setShowVikiMsg", {
        show: false,
        id: null,
        msg: "",
        type: "",
        op: {
          type: "",
          clientId: null,
          userId: null
        },
        options: null,
        updatedAt: null
      });
      this.showWelcome = false;
      this.msgSocket.emit("all_messages");
      /*  setTimeout(function(){ alert("Hello"); }, 3000);*/
    },

    congrats() {
      this.tooBig = false;
      // let userIdToFilter = Object.assign({}, this.showVikiMsg);
      const id = this.auth.user.id;
      // const clientId = userIdToFilter.op.clientId;
      //
      // this.$store.commit("clients/setUpdateAfterCongrats", clientId);
      this.msgSocket.emit("say_congrats", {
        message_from: id,
        msg_id: this.showVikiMsg.id,
        message: this.showVikiMsg.msg,
        approved: "APPROVED",
        type: "RECEIVE_CONGRATS",
        tag: "none",
        operation: "SEND_CONGRATS",
        congrats_to: this.showVikiMsg.op
      });
      this.$store.commit("clients/setChartsMainView", "DEP");
      this.$store.commit("clients/setUpdateDepAfterCongrats", true);
      this.$store.commit("clients/setUpdateLiveChart", true);
      // this.$store.commit("clients/setChartsMainView", "DEP");
      // this.$store.commit("clients/setUpdateDepCharts", {
      //   flag: false,
      //  });

      this.$store.commit("main/setShowVikiMsg", {
        show: false,
        id: null,
        msg: "",
        type: "",
        op: {
          type: "",
          clientId: null,
          userId: null
        },
        options: null,
        updatedAt: null
      });

      this.showWelcome = false;

      //this.msgSocket.emit("all_messages");
    },

    filterCongratsDep() {
      const id = this.auth.user.id;
      const clientId = this.showVikiMsg.op.clientId;

      this.$store.commit("clients/setUpdateAfterCongrats", clientId);

      this.msgSocket.emit("say_congrats", {
        message_from: id,
        msg_id: this.showVikiMsg.id,
        message: this.showVikiMsg.msg,
        approved: "APPROVED",
        type: "RECEIVE_CONGRATS",
        tag: "none",
        operation: "SEND_CONGRATS",
        congrats_to: this.showVikiMsg.op
      });

      this.$store.commit("clients/setChartsMainView", "DEP");
      this.$store.commit("clients/setUpdateDepCharts", {
        flag: true,
        data: this.showVikiMsg
      });
      this.$store.commit("clients/setUpdateLiveChart", true);
      // this.$store.commit("main/setShowVikiMsg", {
      //   show: false,
      //   id: null,
      //   msg: "",
      //   type: "",
      //   op: {
      //     type: "",
      //     clientId: null,
      //     userId: null
      //   }
      // });

      this.showWelcome = false;
    },

    showCaMissedClients() {
      const id = this.auth.user.id;
      this.msgSocket.emit("answer_notification", {
        crm_user_id: id,
        msg_id: this.showVikiMsg.id,
        message: this.showVikiMsg.msg,
        approved: "APPROVED",
        type: this.showVikiMsg.type,
        tag: "no",
        operation: "no"
      });

      this.$store.commit("main/setShowVikiMsg", {
        show: false,
        id: null,
        msg: "",
        type: "",
        op: {
          type: "",
          clientId: null,
          userId: null
        },
        options: null,
        updatedAt: null
      });
      this.showWelcome = false;
      this.msgSocket.emit("all_messages");

      this.$store.commit("clients/setFilterCaMissedClient", true);
    },
    showCaComingClient() {
      const id = this.auth.user.id;
      this.msgSocket.emit("answer_notification", {
        crm_user_id: id,
        msg_id: this.showVikiMsg.id,
        message: this.showVikiMsg.msg,
        approved: "APPROVED",
        type: this.showVikiMsg.type,
        tag: "no",
        operation: "CALL"
      });

      this.setClientToCall(this.showVikiMsg.op.clientId[0].id);
      // op: {userId:data.crm_user_id, type:'CA_COMING',clientId:data.clients}
      this.$store.commit("main/setShowVikiMsg", {
        show: false,
        id: null,
        msg: "",
        type: "",
        op: {
          type: "",
          clientId: null,
          userId: null
        },
        options: null,
        updatedAt: null
      });
      this.showWelcome = false;
      this.msgSocket.emit("all_messages");
    },

    takeMeToMyClientsDep(opCode) {
      const id = this.auth.user.id;
      this.msgSocket.emit("answer_notification", {
        crm_user_id: id,
        msg_id: this.showVikiMsg.id,
        message: this.showVikiMsg.msg,
        approved: "APPROVED",
        type: this.showVikiMsg.type,
        tag: "DEP",
        operation: "FILTER"
      });

      this.setClientsToFilterDepStatus(opCode);
      this.$store.commit("main/setShowVikiMsg", {
        show: false,
        id: null,
        msg: "",
        type: "",
        op: {
          type: "",
          clientId: null,
          userId: null
        },
        op_code: "",
        options: null,
        updatedAt: null
      });
      this.showWelcome = false;
      this.msgSocket.emit("all_messages");
    },

    clear(opt = "") {
      const id = this.auth.user.id;
      this.msgSocket.emit("answer_notification", {
        crm_user_id: id,
        msg_id: this.showVikiMsg.id,
        message: this.showVikiMsg.msg,
        approved: "APPROVED",
        type: this.showVikiMsg.type,
        tag: "none",
        operation: "no"
      });
      this.$store.commit("main/setShowVikiMsg", {
        show: false,
        id: null,
        msg: "",
        type: "",
        op: {
          type: "",
          clientId: null,
          userId: null
        },
        options: null,
        updatedAt: null
      });

      this.showWelcome = false;
      if (opt === "GTT") {
        let vm = this;
        vm.$router.push("/tasks");
      }
    },

    clearTaskMsg(opt = "") {
      const id = this.auth.user.id;
      this.msgSocket.emit("answer_task_notification", {
        crm_user_id: id,
        msg_id: this.showVikiMsg.id,
        message: this.showVikiMsg.msg,
        approved: "APPROVED",
        type: this.showVikiMsg.type,
        tag: "none",
        operation: "no"
      });
      this.$store.commit("main/setShowVikiMsg", {
        show: false,
        id: null,
        msg: "",
        type: "",
        op: {
          type: "",
          clientId: null,
          userId: null
        },
        options: null,
        updatedAt: null
      });

      this.showWelcome = false;
      if (opt === "GTT") {
        let vm = this;
        vm.$router.push("/tasks");
      }
    },
    clearMeetingMsg(opt = "", taskId) {
      const id = this.auth.user.id;
      this.msgSocket.emit("answer_task_notification", {
        crm_user_id: id,
        msg_id: this.showVikiMsg.id,
        message: this.showVikiMsg.msg,
        approved: "APPROVED",
        type: this.showVikiMsg.type,
        tag: "none",
        operation: "no"
      });
      this.$store.commit("main/setShowVikiMsg", {
        show: false,
        id: null,
        msg: "",
        type: "",
        op: {
          type: "",
          clientId: null,
          userId: null
        },
        options: null,
        updatedAt: null
      });

      this.showWelcome = false;
      if (opt === "GTTM") {
        let vm = this;
        vm.$router.push("/tasks");
        this.openMeetingToComplete(taskId);
      }
    },
    async saveScheduledCall(clientId) {
      const newSchedule = moment()
        .add(30, "minutes")
        .format("YYYY-MM-DD HH:mm:ss");

      const newSchduledCall = {
        call_scheduled_on: newSchedule,
        comment: "will call in 30 minutes",
        status_id: 25,
        priority_id: 3
      };
      try {
        this.$store.commit("clients/setLoading", true);
        const apiClient = apiClientCreator(
          `client/schedule-call/${clientId}`,
          "token"
        );
        await apiClient.post("", newSchduledCall);

        this.$emit("update");
        const id = this.auth.user.id;
        this.msgSocket.emit("answer_notification", {
          crm_user_id: id,
          msg_id: this.showVikiMsg.id,
          message: this.showVikiMsg.msg,
          approved: "DECLINED",
          type: this.showVikiMsg.type,
          tag: "none",
          operation: "RESCHEDULE"
        });

        this.showAssignMenu = false;
        this.$store.commit("main/setShowVikiMsg", {
          show: false,
          id: null,
          msg: "",
          type: "",
          op: {
            type: "",
            clientId: null,
            userId: null
          },
          options: null,
          updatedAt: null
        });

        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Scheduled Call\n Completed",
          type: "DONE"
        });

        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Schedule Call Error!\n  Status:" + e.response.status,
          type: "ERROR"
        });

        this.$store.commit("clients/setLoading", false);

        this.msgSocket.emit("all_messages");
      }
    },
    removeHtml(tag) {
      return tag.replace(/<\/?[^>]+(>|$)/g, " ");
    },
    setClientToFilter(clientId) {
      this.$store.commit("clients/setFilterClientById", clientId);
    },
    setClientToCall(clientId) {
      this.$store.commit("clients/setFilterClientToCall", clientId);
    },

    setClientsToFilterDepStatus(opCode) {
      this.$store.commit("clients/setFilterDepStatus", opCode);
    },

    getCountryName(id) {
      return this.dictionaries.general.countries.find(
        country => country.id === JSON.parse(id)
      ).name;
    },

    getPersonName(id) {
      return this.salesPersonList.find(person => person.id === id);
    },
    getRoleType(roleId) {
      return this.dictionaries.general.roles.find(role => role.id === roleId);
    },
    getPersonNameMsg(id) {
      return this.salesPersonList.find(person => person.id === id);
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YY HH:mm");
    },
    setWelcome() {
      const format = "hh:mm:ss";

      const time = moment();

      const morningStart = moment("05:01:00", format);
      const morningEnd = moment("11:00:00", format);

      const afternoonStart = moment("11:01:00", format);
      const afternoonEnd = moment("16:00:00", format);

      const eveningStart = moment("16:01:00", format);
      const eveningEnd = moment("22:00:00", format);

      const nightStart = moment("22:01:00", format);
      const nightEnd = moment("23:59:00", format);
      const nightStart2 = moment("00:00:00", format);
      const nightEnd2 = moment("05:59:00", format);

      if (time.isBetween(morningStart, morningEnd)) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: " Good Morning",
          type: ""
        });
      }

      if (time.isBetween(afternoonStart, afternoonEnd)) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Good Afternoon",
          type: ""
        });
      }

      if (time.isBetween(eveningStart, eveningEnd)) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Good Evening",
          type: ""
        });
      }

      if (
        time.isBetween(nightStart, nightEnd) ||
        time.isBetween(nightStart2, nightEnd2)
      ) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Good Night",
          type: ""
        });
      }
      setTimeout(() => {
        this.showWelcome = false;
        this.$store.commit("main/setShowVikiMsg", {
          show: false,
          msg: "",
          type: ""
        });

        this.getLatestMessages();
      }, 11000);
    },
    async activateClient(clientId) {
      try {
        this.$store.commit("clients/setLoading", true);
        const activateRequest = apiClientCreator(`client/activate/${clientId}`);
        await activateRequest.put("", {
          client_id: this.showVikiMsg.op.clientId
        });
        this.$emit("update");
        this.decline();
        // this.cleanForm();
        /*              this.fetchClients();
                      this.selectedClients = [];*/

        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Client Activation Complete",
          type: "DONE"
        });

        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
            "Client Activation Error!\n" +
            " " +
            " Error Status:\n " +
            e.response.status,
          type: "ERROR"
        });

        this.$store.commit("clients/setLoading", false);
      }
    },

    async saveAssignment(assign) {
      try {
        this.$store.commit("clients/setLoading", true);
        const assignRequest = apiClientCreator(`client/assign/${assign.id}`);
        await assignRequest.put("", {
          client_id: this.showVikiMsg.op.clientId
        });
        this.$emit("update");
        this.decline();
        // this.cleanForm();
        /*              this.fetchClients();
              this.selectedClients = [];*/

        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Client Assignment Complete",
          type: "DONE"
        });

        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg:
            "Client Assignment Error!\n" +
            " " +
            " Error Status:\n " +
            e.response.status,
          type: "ERROR"
        });

        this.$store.commit("clients/setLoading", false);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.searches-container{
  width: 100%;
  padding: 0;
  background: white;
  border-left: 1px solid #dddddd;
  border-right: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
  padding-bottom: 5px;
  max-height: 140px;
  overflow-y: scroll;
}

.searches-container::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.searches-container::-webkit-scrollbar {
  width: 7px;
  background-color: #f5f5f5;
  /*display: none;*/
}

.searches-container::-webkit-scrollbar-thumb {
  background-color: #7a7a7a;
  border: 2px solid #555555;
  border-radius: 3px;
}



.search-preview{
  //border-bottom: 1px solid lightgrey;
  cursor: pointer;
  padding: 2px 0;
}
.search-preview:hover{
  background: lightgrey;
  transition: 0.3s;
}
.search-preview-fake-hover{
  background: lightgrey;
  transition: 0.3s;
}

.col-3 a {
  cursor: pointer;
}

.main {
  position: relative;
  height: 180px;
  padding: 30px;
}

.container {
  width: 100%;
}

.btn-bar {
  position: absolute;
  width: 100%;
  top: 150px;
}

.notification-icon {
  /*margin-top: 13px;*/
  margin-left: 10px;
  word-break: break-all;
}

.notification-icon img {
  margin-top: 5px;
}

.floating-wrapper {
  position: relative;
  text-align: center;
  font-size: 15px;
}

.assignment-dropdown-menu {
  position: absolute;
  z-index: 10001;
  bottom: 30px;
  left: 8px;
  border: solid 1px #90a4ae;
  height: auto;
  max-height: 120px;
  overflow-x: hidden;
  border-radius: 0;
  background: white;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.buttons {
  margin-top: 30px;
}

.button-all {
  margin-top: 30px;
  margin-right: -50px;
}

.button-div {
  display: flex;
  width: 300px;
}

p {
  float: right;
  display: inline-block;
  width: auto;
}

img {
  /*float: left;*/
  display: inline-block;
  /*margin-right: 30px;*/
  /*margin-left: 10px;*/
  /*margin-top: -10px;*/
}

.welcome-message {
  position: absolute;
  top: 160px;
  left: 0;
  font-family: "Montserrat", Montserrat, serif;
  font-size: 13.5px;
  margin-left: 15px;
}

.welcome-message-small {
  position: absolute;
  top: 125px;
  left: 13px;
  font-family: "Montserrat", Montserrat, serif;
  font-size: 13.5px;
  justify-content: start;
}

.newWidthForUserPic {
  margin-left: -13px;
  margin-top: -10px;
  width: 50%;
  height: 50%;
}

.toBigForAgent {
  position: absolute;
  top: 2px;
  left: 13px;
  font-family: "Montserrat", Montserrat, serif;
  font-size: 13.5px;
  justify-content: start;
}

.crm-message {
  margin-top: 15px;
  font-family: "Montserrat", Montserrat, serif;
  font-size: 15px;
  position: absolute;
}

.country-time {
  float: right;
  font-size: 15px;
}

.country-flag {
  margin-top: 3px;
  margin-right: 5px;
}

.viki-msg {
  font-size: 15px;
  color: red;
}

.add-tag-menu-item-title {
  margin: 5px;
  font-size: 15px;
  font-weight: bold;
}

.assign-menu-item {
  margin: 5px;
  font-size: 15px;
  font-family: "Montserrat", Montserrat, serif;
}

.assign-menu-item:hover {
  background: #e0e0e0;
  cursor: pointer;
}

ul {
  list-style: none;
  padding-left: 0;
}

.notifications-list {
  position: absolute;
  width: 720px;
  right: 40px;
  top: 10px;
  /*background-color: #0fb97b;*/
  height: auto;
  max-height: 110px;
  overflow-x: hidden;
  z-index: 10000;
  border: solid 1px #ccc;
  background-color: #fff;
  /*  -webkit-box-shadow: 4px 4px 11px -4px rgba(0,0,0,0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0,0,0,0.75);
  box-shadow: 4px 4px 11px -4px rgba(0,0,0,0.75);*/
}

.msg-datetime {
  width: 100px;
  font-size: 15px;
}

.msg-center {
  position: absolute;
  width: 720px;
  right: 40px;
  top: 10px;
  /*background-color: #0fb97b;*/

  z-index: 10000;
  border: solid 1px #ccc;
  background-color: #fff;
}

.msg-center-overflow {
  height: auto;

  max-height: 80px;
  overflow-x: hidden;
}

.btn-msg-send {
  background-color: #448aff;
  color: #ffffff;
  font-size: 15px;
  height: 30px;
}

.btn-approved {
  background-color: #efefef;
  color: black;
  height: 30px;
  font-size: 15px;
  line-height: 10px;
  margin-right: 10px;
  margin-left: 7px;
  padding-left: 4px !important;
}
.ml-70 {
  margin-left: 70%;
}

.btn-decline {
  background-color: #ff6666;
  color: #ffffff;
  height: 30px;
  font-size: 15px;
  line-height: 10px;
}

.btn-decline-long {
  background-color: #ff6666;
  color: #ffffff;
  height: 30px;
  font-size: 15px;
  line-height: 10px;

  position: absolute;
}

.btn-decline-long-coming-call {
  background-color: #1565c0;
  color: #ffffff;
  height: 30px;
  font-size: 15px;
  line-height: 10px;
  position: absolute;
}

.btn-all {
  background-color: #1565c0;
  color: #ffffff;
  position: absolute;
  height: 30px;
  font-size: 15px;
  line-height: 10px;
  left: 570px;
}

.btn-center {
  background-color: #1565c0;
  color: #ffffff;
  position: absolute;
  height: 30px;
  font-size: 15px;
  line-height: 10px;
  left: 430px;
}

.input-standard {
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 15px;
  box-sizing: border-box;
}

input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: searchfield-cancel-button;
}

input[type="text"],
textarea {
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  outline: none;
  /*  padding: 3px 0px 3px 3px;
  margin: 5px 1px 3px 0px;*/
  border: 1px solid #dddddd;
}

input[type="search"]:focus,
textarea:focus {
  box-shadow: 0 0 5px rgba(81, 203, 238, 1);
  /*padding: 3px 0px 3px 3px;*/

  border: 1px solid rgba(81, 203, 238, 1);
}

.input-msg-div {
  display: flex;
}

.client-id-msg {
  color: #1144bc !important;
  cursor: pointer;
  position: absolute;
  top: 176px;
  left: 48px;
  z-index: 10;
}

.client-id {
  cursor: pointer;
}

.spinner-noti-box {
  position: absolute;
  left: 300px;
  bottom: 2px;
}

.w50 {
  width: calc(10%);
  padding-top: 12px;
}

R .right {
  float: right;
}

.margin {
  /*margin: 0.5rem;*/
}

.margin_l_hf {
  /*margin-left: 0.2rem;*/
}

.margin_r_c {
  /*margin-right: 0;*/
}

.styleCard {
  overflow: hidden;
  height: 200px;
  font-family: "Montserrat", Montserrat, serif;
  position: relative;
  border-radius: 7px !important;
  padding-top: 12px;
  font-size: 12px;
}

.styleCardContent {
  background: white;
  min-height: 12rem;
  height: 100%;
}

.sysChat {
  display: flex;
  flex-wrap: wrap;
}

.padding {
  padding: 0rem 5px 5px 5px;
}

.ai-avatar {
  /*flex: 1;*/
  /*min-width: 17.5%;*/
  /*border: 1px solid black;*/
  //padding-top: 12px;
}

.ai-avatar img {
  border-radius: 5px;
  max-width: 78%;
  /*cursor: pointer;*/
  margin-left: 13%;
}

.rootWindowTooBigForAgent {
  border-radius: 5px;
  max-width: 80%;
  animation-name: resize;
  width: 70%;
  height: 50%;
  margin-left: 10%;
  transition-duration: 0.7s;
}

.ai-avatar-img {
  width: 180px;
  height: 197px;
  overflow: hidden;
  position: relative;
  margin: auto;
  border-radius: 5px;
}

.sysChatContent {
  flex: 8;
  /*border: 1px solid #ebeff2;*/
  border-radius: 5px 5px 0 0;
  /*margin-left: 1rem;*/
  /*padding-left: 5px;*/
  position: relative;
  height: 80%;
  font-family: "Montserrat", Montserrat, serif;
  font-size: 15px !important;
  max-width: 80%;
}

.sysChatContentTemp {
  flex: 8;
  /*border: 1px solid #ebeff2;*/
  border-radius: 5px 5px 0 0;
  /*margin-left: 1rem;*/
  /*padding-left: 5px;*/
  position: relative;
  height: 80%;
  font-family: "Montserrat", Montserrat, serif;
  font-size: 15px !important;
  max-width: 99%;
}

.sysChatActions {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #ebeff2;
}

.sysChatActions input {
  width: calc(100% - 80px);
  padding: 0.7rem;
  border: 0;
}

.sysChatText {
  height: calc(100% - 3.5rem);
  overflow-y: scroll;
  padding: 0.5rem;
}

.sysChatText-notification {
  height: 100%;
  overflow-y: scroll;
  padding: 0.5rem;
}

.sysChatActions input {
  width: calc(100% - 80px);
  padding: 0.7rem;
  border: 0;
}

.sysChatActions button:hover img {
  transform: translateX(10px);
}

.sysChatActions button img {
  transition: transform 0.3s ease;
}

.sysChatActions button {
  width: 75px;
  background: none;
  border: 0;
  position: absolute;
  top: 0.1rem;
  right: 0;
  text-align: center;
  cursor: pointer;
  height: 37px;
}

.bttn {
  width: max-content;
  margin-top: 0.5rem;
  margin-left: 0.5rem;
  background: #efefef !important;
  color: #000000;
  border: 0;
  border-radius: inherit;
  padding: 5px;
  font-size: 12px;
  font-family: "Montserrat" !important;
  cursor: pointer;
  height: 28px;
}

.bttn:focus {
  outline: none !important;
}

.col-md-4 > i:focus {
  outline: none !important;
}

.notifi-table {
  width: 690px !important;
  font-size: 15px;
}

.empty-div {
  width: 100%;
}

.button-box {
  position: absolute;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-evenly;
  bottom: -4px;
  //right: 20%;
  max-width: -webkit-fit-content;
  max-width: -moz-fit-content;
  max-width: fit-content;
  min-width: 100%;
  flex-direction: column;
  //top: 150px;
}

/*.button-box .bttn {*/
/*  font-size: 8px !important;*/
/*  height: unset !important;*/
/*}*/
.date-time-div {
  /*font-weight: bold;*/
  font-size: 15px;
  float: right;
  margin-right: 234px;
  margin-top: 11px;
  color: #000;
}

.buttons-area {
  //padding-left: 27px !important;
}

.buttons-area button {
  /*color: #bf3dff;*/
  /*border: 1px solid #bf3dff;*/
  /*position: absolute;*/
  /*border-radius: 0px !important;*/
  /*text-transform: uppercase;*/
  /*font-size: 13px;*/
  /*background: white;*/
  /*top: 24px;*/
  /*height: 26px;*/
  /*border-radius: 5px !important;*/
  /*right: 77px;*/
  color: #bf3dff;
  border: 1px solid #bf3dff;
  /*position: absolute;*/
  border-radius: 0px !important;
  text-transform: uppercase;
  font-size: 10px;
  background: white;
  width: fit-content;
  /*top: 24px;*/
  height: 26px;
  padding-left: 8px !important;
  border-radius: 5px !important;
  /*right: 38px;*/
  margin-top: 9%;
  /*
  margin-left: 30%;
*/
}

.country-img {
  width: 40px;
  position: absolute;
  top: 176px;
  left: 123px;
}

.viki-stats-chart {
  height: 80%;
}

.test {
  /*width: 158px;*/
  /*height: 158px;*/
  /*top: 35px;*/
  /*right: 5px;*/
  /*position: absolute;*/
  width: 62px;
  height: 71px;
  top: 1px;
  left: 84px;
  position: absolute;
}

.test-agent {
  width: 62px;
  height: 71px;
  top: 10px;
  left: 84px;
  position: absolute;
}

.special {
  margin-left: 0;
}

span.vue-typer {
  cursor: default;
  -webkit-user-select: none;
  -moz-user-select: none;
  /* margin-top: 100px; */
  position: absolute;
  top: 111px;
  left: 40px !important;
  -ms-user-select: none;
  user-select: none;
  font-size: 14px;
}

span.vue-typer-agent {
  cursor: default;
  -webkit-user-select: none;
  -moz-user-select: none;
  /* margin-top: 100px; */
  position: absolute;
  top: 125px;
  left: 35px;
  user-select: none;
}

.forBorder {
  //border-bottom: 1px solid;
  width: 130px;
  padding-left: -32px;
  padding-right: -34px;
  padding-top: 8px;
  left: 0;
}

.rootWindow {
  -webkit-transition-property: height, width;
  -webkit-transition-duration: 1s;
  -moz-transition-property: height, width;
  -moz-transition-duration: 1s;
  transition-property: height, width;
  transition-duration: 1s;
  width: 100%;
  height: 100%;
}

.rootWindowTooBig {
  /*margin-left: 20%;*/

  animation-name: resize;
  /*animation-duration: 4s;*/
  width: 70%;
  height: 50%;
  margin-right: auto;
  margin-left: auto;
  transition-duration: 0.7s;
}

/*.toBigForAgent {*/
/*  margin-left: 15px;*/
/*  margin-top: 10px;*/
/*  width: 50%;*/
/*  height: 50%;*/
/*}*/
/*.img-welcome {*/
/*  margin-top: 8px;*/
/*  height: 100%;*/
/*  width: 100%;*/
/*}*/
/*.img-after-welcome {*/
/*  height: 100%;*/
/*  width: 100%;*/
/*}*/
/*.loader-viki {*/
/*  position: absolute;*/
/*  top: 35%;*/
/*  left: 45%;*/
/*}*/
/*.rowForVickiAndPic {*/
/*  display: flex;*/
/*  flex-direction: row;*/
/*}*/
.auto {
  margin-right: auto;
  margin-left: auto;
}
.agent-pic {
  margin-top: 25px;
}

.flag-and-id {
  position: absolute;
  top: 0px;
  left: 28px;
}

.col-md-4 {
  color: #808080;
  font-size: 16px;
}

.col-md-4 i:hover {
  cursor: pointer;
}

.row {
  font-size: initial;
  margin-right: -40px;
  //margin-left: 1px;
}
.row-reset {
  margin: 0;
  display: flex;
  justify-content: space-around;
}

.for-coffee {
  font-size: 27px;
  margin-top: 50%;
}

.for-coffee-icone {
  font-size: 27px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #808080;
}

.cancelOrder {
  font-size: 19px;
  margin-top: 5%;
  color: #7a7a7a;
  max-height: 19px;
  position: absolute !important;
  top: 145px !important;
  right: 30px !important;
}

.for-hover-cancelOrder:hover {
  /*border: 1px solid #cbc26f;*/
  //border-radius: 5px;
  cursor: pointer;
  color: #2d2b2b;
}

.tagNameDesignForCoffee {
  font-size: 14px;
  color: #7a7a7a;
}

.tagNameDesignForCoffee:hover {
  cursor: pointer;
  color: #2d2b2b;
}

.tagNameDesignForComeHere {
  font-size: initial;
  //position: absolute;
  color: #7a7a7a;
  //top: -2px;
}

.tagNameDesignForComeHere:hover {
  cursor: pointer;
  color: #2d2b2b;
}

.tagNameDesignForViki {
  /* //border: 1px solid white;
  border-radius: 5px;*/
  color: #7a7a7a;
}

.tagNameDesignForViki:hover {
  color: #2d2b2b;
  /*
  border-radius: 5px;
*/
  //padding: 2px;
  //margin-right: 3px;
}

.sendIt {
  display: block;
  float: unset !important;
  font-size: 11px;
  padding-left: 4px;
  color: #cbc26f;
  cursor: pointer;
}

.success-order {
}

.coloredY {
  color: #cbc26f !important;
}

.colored {
  color: #808080;
  /*border: 1px solid #cbc26f;*/
  /*border-radius: 5px;*/
  /*padding: 2px;*/
}

.reset {
  position: absolute;
  background: none;
}

.btn-trash:focus {
  outline: none !important;
}

@keyframes rotate {
  100% {
    transform: rotate(1turn);
  }
}

.doneDebounce {
  position: relative;
  z-index: 0;
  width: 191px;
  height: 200px;
  border-radius: 10px;
  overflow: hidden;
  padding: 2rem;
  padding-top: 12px;

  &::before {
    content: "";
    position: absolute;
    z-index: -2;
    left: -50%;
    top: -50%;
    width: 200%;
    height: 200%;
    background-color: white;
    background-repeat: no-repeat;
    background-size: 50% 50%, 50% 50%;
    background-position: 0 0, 100% 0, 100% 100%, 0 100%;
    background-image: linear-gradient(#cbc26f);
    animation: rotate 0.75s ease infinite;

    /*animation:  flash-data-v-297c3b56 2s linear infinite;*/
    /*animation: rotate 0.75s linear infinite;*/
  }

  &::after {
    content: "";
    position: absolute;
    z-index: -1;
    left: 1px;
    top: 1px;
    width: calc(99.5% - 1px);
    height: calc(98.9%);
    background: white;
    border-radius: 5px;
  }
}

.dNone {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 25%;
  text-align: center;
  font-size: 18px;
  /*z-index: 9999;*/
  /*z-index: 1;*/
  opacity: 0.7;
  border: 4px solid #808080 !important;
  /*border-top: 4px solid #3498db;*/
  border-radius: 50%;
  width: 15px;
  height: 15px;
  /*animation: spin 2s linear infinite;*/
  top: 12px;
  right: 37px;
}

.loaderNewV {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 25%;
  text-align: center;
  font-size: 18px;
  opacity: 0.7;
  border: 4px solid #808080;
  border-top: 4px solid #cbc26f;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  -webkit-animation: spin-data-v-52899fd5 2s linear infinite;
  animation: spin-data-v-52899fd5 2s linear infinite;
  top: 11px;
  right: 37px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.tabName {
  color: #696969 !important;
}

.tabName:hover {
  cursor: pointer;
  color: #44a2d2 !important;
}

.for-border {
  border: 1px solid #cbc26f;
  border-radius: 5px;
}

@keyframes resize {
  from {
    width: 100%;
  }
  from {
    height: 100%;
  }
  to {
    width: 70%;
  }
  to {
    height: 50%;
  }
}

.disabledIt {
  cursor: not-allowed !important;
  opacity: 0.3 !important;
}

.icone-text:hover {
  color: #cbc26f;
  cursor: pointer;
}

.stp-process {
  top: 5px;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  margin-top: 0;
  margin-left: 0.5rem;
  background: none !important;
  color: #000000;
  border: 0;
  position: absolute;
  border-radius: inherit;
  right: 26px;
  padding: 5px;
  font-size: 12px;
  font-family: "Montserrat" !important;
  cursor: pointer;
  height: 0px;
}

.for-agent-pic-dep {
  max-width: 50%;
  margin-top: 10%;
}

.viki-when-dep-with-user {
  max-width: 56% !important;
  padding: 0;
  padding-top: 16% !important;
  /*float: right;*/
  margin-left: 50% !important;
}

.temp-for-s_c {
  margin-bottom: 3%;
}

.btn-dangerr {
  margin-right: 51px !important;
  position: absolute;
  left: 79px;
  color: rgb(130, 119, 23) !important;
  border: unset !important;
}

.btn-dangerr:focus {
  outline: none;
}

.fa-times {
  margin-bottom: 7px;
  position: absolute;
  top: 20px;
  left: 6px;
}

.order {
  /* margin-right: -26px; */
  position: absolute;
  left: 76px;
  top: 159px;
  color: #cbc26f;
  cursor: pointer;
}

.beta-item {
  font-size: 11px;
  position: absolute;
  top: 8px;
  width: 100%;
}

.beta-icon {
  font-size: 11px;
}

.for-filter-my-clients {
  position: absolute;
  top: 5px;
  left: 117px;
}
.ml-45 {
  left: 110px;
}

.for-remind-in-h {
  position: absolute;
  top: 5px;
  left: 50px;
}

.for-remind-tomorrow {
  position: absolute;
  top: 5px;
  left: 100px;
}

.call-now {
  position: absolute;
  top: 7px;
  left: -15px;
}

.remind-me {
  position: absolute;
  top: 7px;
  left: 80px;
}

.for-fa-times {
  position: absolute;
  left: 140px;
}

.filter-task {
  color: #bf3dff;
  border: 1px solid #bf3dff;
  border-radius: 0 !important;
  text-transform: uppercase;
  font-size: 10px;
  background: #fff;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  height: 10px;
  padding-left: 11px !important;
  border-radius: 5px !important;
  margin-top: 1%;
  position: absolute;
  top: 5px;
  left: 64px;
}

.dep {
  //padding: 12px;
}
.new-dep {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.later {
  color: #bf3dff;
  border: 1px solid #bf3dff;
  border-radius: 0 !important;
  text-transform: uppercase;
  font-size: 10px;
  background: #fff;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  height: 10px;
  padding-left: 11px !important;
  border-radius: 5px !important;
  margin-top: 1%;
  position: absolute;
  top: 5px;
  left: -17px;
}
.ml-37 {
  margin-left: 37px;
}
.ml6 {
  margin-left: 65%;
}

.history-btn {
  color: #7a7a7a;
}

.history-btn:hover {
  color: #2d2b2b;
}

i {
  cursor: pointer;
}
.meeting-opt {
  height: 22px !important;
}
.not-now {
  margin-top: 14% !important;
}
.viki-search {
  width: 100%;
  text-align: center;
}

.viki-search-form{
  direction: rtl;
}
.viki-search-form>.viki-search-child{
  direction: ltr;
}
.b-0{
  border-bottom: none !important
}
.p15 {
  padding: 0 15px;
}
.remind-btns {
  margin-top: 8px;
}
.p7 {
  padding: 0 7px;
}
.blessing-time {
  text-align: center;
}
.info {
  color: grey;
}
.info:hover {
  color: #2d2b2b;
}
.p0 {
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 8px;
}
.search-btn{
  position: absolute;
  top: 4px;
  right: 174px;
  color: lightgray;
}
</style>
